"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               unknown
// source: rocketchat/api/api.proto
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateBlockStatusResponse = exports.UpdateBlockStatusRequest = exports.GetSafeNumberResponse = exports.GetSafeNumberRequest = exports.GetStickersResponse_Sticker = exports.GetStickersResponse = exports.GetStickersRequest = exports.GetBizAccountResponse = exports.GetBizAccountRequest = exports.GetBizAccountsResponse = exports.GetBizAccountsRequest = exports.DeletePromiseResponse = exports.DeletePromiseRequest = exports.UpdatePromiseResponse = exports.UpdatePromiseRequest = exports.CreatePromiseResponse = exports.CreatePromiseRequest = exports.GetUnreadCountResponse = exports.GetUnreadCountRequest = exports.GetChannelResponse = exports.GetChannelRequest = exports.UpdateUserChannelResponse = exports.UpdateUserChannelRequest = exports.LeaveChannelResponse = exports.LeaveChannelRequest = exports.MarkAsReadResponse = exports.MarkAsReadRequest = exports.GetMessagesResponse = exports.GetMessagesRequest = exports.GetSellerChannelsResponse = exports.GetSellerChannelsRequest = exports.GetChannelsResponse = exports.GetChannelsRequest_PagingKey = exports.GetChannelsRequest = exports.AckEventRequest = exports.SendMessageResponse = exports.SendMessageRequest_TagsEntry = exports.SendMessageRequest = exports.CreateChannelResponse = exports.CreateChannelRequest_TagsEntry = exports.CreateChannelRequest = exports.Response = exports.StatusAction = exports.Request_PropsEntry = exports.Request = exports.DeleteMessageRequest_DeleteByRole = exports.GetChannelsRequest_PagingKey_Kind = exports.Range = exports.Status = exports.protobufPackage = void 0;
exports.GetFiltersResponse = exports.GetFiltersRequest = exports.SendButtonPostbackResponse = exports.SendButtonPostbackRequest = exports.SearchMembersResponse = exports.SearchMembersRequest = exports.GetMemberResponse = exports.GetMemberRequest = exports.GetMembersResponse = exports.GetMembersRequest = exports.ListReactionResponse = exports.ListReactionRequest = exports.SetReactionResponse = exports.SetReactionRequest = exports.DeleteAnnouncementResponse = exports.DeleteAnnouncementRequest = exports.CreateAnnouncementResponse = exports.CreateAnnouncementRequest = exports.DeleteAutoReplyResponse = exports.DeleteAutoReplyRequest = exports.UpdateAutoReplyResponse = exports.UpdateAutoReplyRequest = exports.GetAutoReplyResponse = exports.GetAutoReplyRequest = exports.ListAutoRepliesResponse = exports.ListAutoRepliesRequest = exports.CreateAutoReplyResponse = exports.CreateAutoReplyRequest = exports.UpdateAutoReplyMetadataResponse = exports.UpdateAutoReplyMetadataRequest = exports.GetAutoReplyMetadataResponse = exports.GetAutoReplyMetadataRequest = exports.SendPersistentMenuPostbackResponse = exports.SendPersistentMenuPostbackRequest = exports.DeleteMessageResponse = exports.DeleteMessageRequest = exports.CloseChannelListHeaderResponse = exports.CloseChannelListHeaderRequest = exports.GetChannelListHeaderResponse = exports.GetChannelListHeaderRequest = exports.RejectVoiceChannelResponse = exports.RejectVoiceChannelRequest = exports.CancelVoiceChannelResponse = exports.CancelVoiceChannelRequest = exports.GetRtcTokenResponse_UidsEntry = exports.GetRtcTokenResponse = exports.GetRtcTokenRequest = exports.BanUserResponse = exports.BanUserRequest = void 0;
exports.statusFromJSON = statusFromJSON;
exports.statusToJSON = statusToJSON;
exports.statusToNumber = statusToNumber;
exports.rangeFromJSON = rangeFromJSON;
exports.rangeToJSON = rangeToJSON;
exports.rangeToNumber = rangeToNumber;
exports.getChannelsRequest_PagingKey_KindFromJSON = getChannelsRequest_PagingKey_KindFromJSON;
exports.getChannelsRequest_PagingKey_KindToJSON = getChannelsRequest_PagingKey_KindToJSON;
exports.getChannelsRequest_PagingKey_KindToNumber = getChannelsRequest_PagingKey_KindToNumber;
exports.deleteMessageRequest_DeleteByRoleFromJSON = deleteMessageRequest_DeleteByRoleFromJSON;
exports.deleteMessageRequest_DeleteByRoleToJSON = deleteMessageRequest_DeleteByRoleToJSON;
exports.deleteMessageRequest_DeleteByRoleToNumber = deleteMessageRequest_DeleteByRoleToNumber;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const timestamp_1 = require("../../google/protobuf/timestamp");
const event_1 = require("./event");
const model_1 = require("./model");
exports.protobufPackage = "api";
/** Status는 Response의 상태를 나타낸다. */
var Status;
(function (Status) {
    Status["UNKNOWN"] = "UNKNOWN";
    Status["OK"] = "OK";
    Status["INVALID_REQUEST_NAME"] = "INVALID_REQUEST_NAME";
    Status["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    Status["FORBIDDEN"] = "FORBIDDEN";
    Status["BAD_REQUEST"] = "BAD_REQUEST";
    Status["NOT_FOUND"] = "NOT_FOUND";
    /** BLOCKED_USER - 메시지를 받는 사람이 차단한 경우 */
    Status["BLOCKED_USER"] = "BLOCKED_USER";
    /** BLOCKED_BY_ME - 메시지를 보내는 사람이 차단한 경우 */
    Status["BLOCKED_BY_ME"] = "BLOCKED_BY_ME";
    /** TOO_LONG_CONTENT - 메시지의 글자수가 1000자를 초과한 경우 */
    Status["TOO_LONG_CONTENT"] = "TOO_LONG_CONTENT";
    /** BLOCKED_STATUS_USER - 이용정지 상태인 유저 */
    Status["BLOCKED_STATUS_USER"] = "BLOCKED_STATUS_USER";
    /**
     * NOT_FOUND_RECEIVER - Deprecated.
     *
     * @deprecated
     */
    Status["NOT_FOUND_RECEIVER"] = "NOT_FOUND_RECEIVER";
    /** DO_NOT_DISTURB - 요청이 방해금지시간으로 인해 이뤄지지 못하는 경우 */
    Status["DO_NOT_DISTURB"] = "DO_NOT_DISTURB";
    /**
     * BANNED_USER - 채널에 입장할 권한이 없는 경우
     * ex) 그룹챗에서 밴당한 유저
     */
    Status["BANNED_USER"] = "BANNED_USER";
})(Status || (exports.Status = Status = {}));
function statusFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return Status.UNKNOWN;
        case 1:
        case "OK":
            return Status.OK;
        case 2:
        case "INVALID_REQUEST_NAME":
            return Status.INVALID_REQUEST_NAME;
        case 3:
        case "INTERNAL_SERVER_ERROR":
            return Status.INTERNAL_SERVER_ERROR;
        case 4:
        case "FORBIDDEN":
            return Status.FORBIDDEN;
        case 5:
        case "BAD_REQUEST":
            return Status.BAD_REQUEST;
        case 11:
        case "NOT_FOUND":
            return Status.NOT_FOUND;
        case 12:
        case "BLOCKED_USER":
            return Status.BLOCKED_USER;
        case 13:
        case "BLOCKED_BY_ME":
            return Status.BLOCKED_BY_ME;
        case 14:
        case "TOO_LONG_CONTENT":
            return Status.TOO_LONG_CONTENT;
        case 15:
        case "BLOCKED_STATUS_USER":
            return Status.BLOCKED_STATUS_USER;
        case 16:
        case "NOT_FOUND_RECEIVER":
            return Status.NOT_FOUND_RECEIVER;
        case 17:
        case "DO_NOT_DISTURB":
            return Status.DO_NOT_DISTURB;
        case 18:
        case "BANNED_USER":
            return Status.BANNED_USER;
        default:
            return Status.UNKNOWN;
    }
}
function statusToJSON(object) {
    switch (object) {
        case Status.UNKNOWN:
            return "UNKNOWN";
        case Status.OK:
            return "OK";
        case Status.INVALID_REQUEST_NAME:
            return "INVALID_REQUEST_NAME";
        case Status.INTERNAL_SERVER_ERROR:
            return "INTERNAL_SERVER_ERROR";
        case Status.FORBIDDEN:
            return "FORBIDDEN";
        case Status.BAD_REQUEST:
            return "BAD_REQUEST";
        case Status.NOT_FOUND:
            return "NOT_FOUND";
        case Status.BLOCKED_USER:
            return "BLOCKED_USER";
        case Status.BLOCKED_BY_ME:
            return "BLOCKED_BY_ME";
        case Status.TOO_LONG_CONTENT:
            return "TOO_LONG_CONTENT";
        case Status.BLOCKED_STATUS_USER:
            return "BLOCKED_STATUS_USER";
        case Status.NOT_FOUND_RECEIVER:
            return "NOT_FOUND_RECEIVER";
        case Status.DO_NOT_DISTURB:
            return "DO_NOT_DISTURB";
        case Status.BANNED_USER:
            return "BANNED_USER";
        default:
            return "UNKNOWN";
    }
}
function statusToNumber(object) {
    switch (object) {
        case Status.UNKNOWN:
            return 0;
        case Status.OK:
            return 1;
        case Status.INVALID_REQUEST_NAME:
            return 2;
        case Status.INTERNAL_SERVER_ERROR:
            return 3;
        case Status.FORBIDDEN:
            return 4;
        case Status.BAD_REQUEST:
            return 5;
        case Status.NOT_FOUND:
            return 11;
        case Status.BLOCKED_USER:
            return 12;
        case Status.BLOCKED_BY_ME:
            return 13;
        case Status.TOO_LONG_CONTENT:
            return 14;
        case Status.BLOCKED_STATUS_USER:
            return 15;
        case Status.NOT_FOUND_RECEIVER:
            return 16;
        case Status.DO_NOT_DISTURB:
            return 17;
        case Status.BANNED_USER:
            return 18;
        default:
            return 0;
    }
}
/** Range를 설정할 때 쓰인다. */
var Range;
(function (Range) {
    Range["GREATER"] = "GREATER";
    Range["GREATER_EQUAL"] = "GREATER_EQUAL";
    Range["EQUAL"] = "EQUAL";
    Range["LESS"] = "LESS";
    Range["LESS_EQUAL"] = "LESS_EQUAL";
})(Range || (exports.Range = Range = {}));
function rangeFromJSON(object) {
    switch (object) {
        case 0:
        case "GREATER":
            return Range.GREATER;
        case 1:
        case "GREATER_EQUAL":
            return Range.GREATER_EQUAL;
        case 2:
        case "EQUAL":
            return Range.EQUAL;
        case 3:
        case "LESS":
            return Range.LESS;
        case 4:
        case "LESS_EQUAL":
            return Range.LESS_EQUAL;
        default:
            return Range.GREATER;
    }
}
function rangeToJSON(object) {
    switch (object) {
        case Range.GREATER:
            return "GREATER";
        case Range.GREATER_EQUAL:
            return "GREATER_EQUAL";
        case Range.EQUAL:
            return "EQUAL";
        case Range.LESS:
            return "LESS";
        case Range.LESS_EQUAL:
            return "LESS_EQUAL";
        default:
            return "GREATER";
    }
}
function rangeToNumber(object) {
    switch (object) {
        case Range.GREATER:
            return 0;
        case Range.GREATER_EQUAL:
            return 1;
        case Range.EQUAL:
            return 2;
        case Range.LESS:
            return 3;
        case Range.LESS_EQUAL:
            return 4;
        default:
            return 0;
    }
}
var GetChannelsRequest_PagingKey_Kind;
(function (GetChannelsRequest_PagingKey_Kind) {
    GetChannelsRequest_PagingKey_Kind["KIND_UNSPECIFIED"] = "KIND_UNSPECIFIED";
    GetChannelsRequest_PagingKey_Kind["KIND_NORMAL"] = "KIND_NORMAL";
    GetChannelsRequest_PagingKey_Kind["KIND_FAVORITE"] = "KIND_FAVORITE";
})(GetChannelsRequest_PagingKey_Kind || (exports.GetChannelsRequest_PagingKey_Kind = GetChannelsRequest_PagingKey_Kind = {}));
function getChannelsRequest_PagingKey_KindFromJSON(object) {
    switch (object) {
        case 0:
        case "KIND_UNSPECIFIED":
            return GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED;
        case 1:
        case "KIND_NORMAL":
            return GetChannelsRequest_PagingKey_Kind.KIND_NORMAL;
        case 2:
        case "KIND_FAVORITE":
            return GetChannelsRequest_PagingKey_Kind.KIND_FAVORITE;
        default:
            return GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED;
    }
}
function getChannelsRequest_PagingKey_KindToJSON(object) {
    switch (object) {
        case GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED:
            return "KIND_UNSPECIFIED";
        case GetChannelsRequest_PagingKey_Kind.KIND_NORMAL:
            return "KIND_NORMAL";
        case GetChannelsRequest_PagingKey_Kind.KIND_FAVORITE:
            return "KIND_FAVORITE";
        default:
            return "KIND_UNSPECIFIED";
    }
}
function getChannelsRequest_PagingKey_KindToNumber(object) {
    switch (object) {
        case GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED:
            return 0;
        case GetChannelsRequest_PagingKey_Kind.KIND_NORMAL:
            return 1;
        case GetChannelsRequest_PagingKey_Kind.KIND_FAVORITE:
            return 2;
        default:
            return 0;
    }
}
var DeleteMessageRequest_DeleteByRole;
(function (DeleteMessageRequest_DeleteByRole) {
    /** DELETE_BY_UNSPECIFIED - DELETE_BY_SENDER와 동일 */
    DeleteMessageRequest_DeleteByRole["DELETE_BY_UNSPECIFIED"] = "DELETE_BY_UNSPECIFIED";
    /** DELETE_BY_SENDER - 메시지 삭제: Sender가 자신이고, 발송 5분 이내만 가능 */
    DeleteMessageRequest_DeleteByRole["DELETE_BY_SENDER"] = "DELETE_BY_SENDER";
    /** DELETE_BY_OWNER - 메시지 가리기: 그룹 채팅방의 Owner이고 Sender가 자신이 아닐 경우 가능 */
    DeleteMessageRequest_DeleteByRole["DELETE_BY_OWNER"] = "DELETE_BY_OWNER";
    /** DELETE_BY_SENDER_FOR_PRIVACY - 메시지 삭제: Sender가 자신이고, 개인정보가 포함된 메시지일 경우 가능 */
    DeleteMessageRequest_DeleteByRole["DELETE_BY_SENDER_FOR_PRIVACY"] = "DELETE_BY_SENDER_FOR_PRIVACY";
})(DeleteMessageRequest_DeleteByRole || (exports.DeleteMessageRequest_DeleteByRole = DeleteMessageRequest_DeleteByRole = {}));
function deleteMessageRequest_DeleteByRoleFromJSON(object) {
    switch (object) {
        case 0:
        case "DELETE_BY_UNSPECIFIED":
            return DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED;
        case 0:
        case "DELETE_BY_SENDER":
            return DeleteMessageRequest_DeleteByRole.DELETE_BY_SENDER;
        case 1:
        case "DELETE_BY_OWNER":
            return DeleteMessageRequest_DeleteByRole.DELETE_BY_OWNER;
        case 2:
        case "DELETE_BY_SENDER_FOR_PRIVACY":
            return DeleteMessageRequest_DeleteByRole.DELETE_BY_SENDER_FOR_PRIVACY;
        default:
            return DeleteMessageRequest_DeleteByRole.DELETE_BY_SENDER;
    }
}
function deleteMessageRequest_DeleteByRoleToJSON(object) {
    switch (object) {
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED:
            return "DELETE_BY_UNSPECIFIED";
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_SENDER:
            return "DELETE_BY_SENDER";
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_OWNER:
            return "DELETE_BY_OWNER";
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_SENDER_FOR_PRIVACY:
            return "DELETE_BY_SENDER_FOR_PRIVACY";
        default:
            return "DELETE_BY_SENDER";
    }
}
function deleteMessageRequest_DeleteByRoleToNumber(object) {
    switch (object) {
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED:
            return 0;
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_SENDER:
            return 0;
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_OWNER:
            return 1;
        case DeleteMessageRequest_DeleteByRole.DELETE_BY_SENDER_FOR_PRIVACY:
            return 2;
        default:
            return 0;
    }
}
function createBaseRequest() {
    return {
        name: "",
        props: {},
        id: "",
        echo: "",
        biz_account_id: "0",
        send_message: undefined,
        get_channels: undefined,
        get_messages: undefined,
        create_channel: undefined,
        mark_as_read: undefined,
        leave_channel: undefined,
        update_user_channel: undefined,
        get_channel: undefined,
        get_seller_channels: undefined,
        get_unread_count: undefined,
        create_promise: undefined,
        update_promise: undefined,
        delete_promise: undefined,
        get_biz_accounts: undefined,
        get_biz_account: undefined,
        get_stickers: undefined,
        get_safe_number: undefined,
        update_block_status: undefined,
        ban_user: undefined,
        get_rtc_token: undefined,
        cancel_voice_channel: undefined,
        reject_voice_channel: undefined,
        get_channel_list_header: undefined,
        close_channel_list_header: undefined,
        delete_message: undefined,
        send_persistent_menu_postback: undefined,
        get_auto_reply_metadata: undefined,
        update_auto_reply_metadata: undefined,
        list_auto_replies: undefined,
        create_auto_reply: undefined,
        get_auto_reply: undefined,
        update_auto_reply: undefined,
        delete_auto_reply: undefined,
        create_announcement: undefined,
        delete_announcement: undefined,
        set_reaction: undefined,
        list_reaction: undefined,
        get_filters: undefined,
        get_member: undefined,
        get_members: undefined,
        search_members: undefined,
        send_button_postback: undefined,
        ack_event: undefined,
    };
}
exports.Request = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        Object.entries(message.props).forEach(([key, value]) => {
            exports.Request_PropsEntry.encode({ key: key, value }, writer.uint32(18).fork()).ldelim();
        });
        if (message.id !== "") {
            writer.uint32(26).string(message.id);
        }
        if (message.echo !== "") {
            writer.uint32(34).string(message.echo);
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(40).int64(message.biz_account_id);
        }
        if (message.send_message !== undefined) {
            exports.SendMessageRequest.encode(message.send_message, writer.uint32(802).fork())
                .ldelim();
        }
        if (message.get_channels !== undefined) {
            exports.GetChannelsRequest.encode(message.get_channels, writer.uint32(810).fork())
                .ldelim();
        }
        if (message.get_messages !== undefined) {
            exports.GetMessagesRequest.encode(message.get_messages, writer.uint32(818).fork())
                .ldelim();
        }
        if (message.create_channel !== undefined) {
            exports.CreateChannelRequest.encode(message.create_channel, writer.uint32(826).fork()).ldelim();
        }
        if (message.mark_as_read !== undefined) {
            exports.MarkAsReadRequest.encode(message.mark_as_read, writer.uint32(834).fork())
                .ldelim();
        }
        if (message.leave_channel !== undefined) {
            exports.LeaveChannelRequest.encode(message.leave_channel, writer.uint32(842).fork()).ldelim();
        }
        if (message.update_user_channel !== undefined) {
            exports.UpdateUserChannelRequest.encode(message.update_user_channel, writer.uint32(850).fork()).ldelim();
        }
        if (message.get_channel !== undefined) {
            exports.GetChannelRequest.encode(message.get_channel, writer.uint32(858).fork())
                .ldelim();
        }
        if (message.get_seller_channels !== undefined) {
            exports.GetSellerChannelsRequest.encode(message.get_seller_channels, writer.uint32(866).fork()).ldelim();
        }
        if (message.get_unread_count !== undefined) {
            exports.GetUnreadCountRequest.encode(message.get_unread_count, writer.uint32(874).fork()).ldelim();
        }
        if (message.create_promise !== undefined) {
            exports.CreatePromiseRequest.encode(message.create_promise, writer.uint32(882).fork()).ldelim();
        }
        if (message.update_promise !== undefined) {
            exports.UpdatePromiseRequest.encode(message.update_promise, writer.uint32(890).fork()).ldelim();
        }
        if (message.delete_promise !== undefined) {
            exports.DeletePromiseRequest.encode(message.delete_promise, writer.uint32(898).fork()).ldelim();
        }
        if (message.get_biz_accounts !== undefined) {
            exports.GetBizAccountsRequest.encode(message.get_biz_accounts, writer.uint32(906).fork()).ldelim();
        }
        if (message.get_biz_account !== undefined) {
            exports.GetBizAccountRequest.encode(message.get_biz_account, writer.uint32(914).fork()).ldelim();
        }
        if (message.get_stickers !== undefined) {
            exports.GetStickersRequest.encode(message.get_stickers, writer.uint32(922).fork())
                .ldelim();
        }
        if (message.get_safe_number !== undefined) {
            exports.GetSafeNumberRequest.encode(message.get_safe_number, writer.uint32(930).fork()).ldelim();
        }
        if (message.update_block_status !== undefined) {
            exports.UpdateBlockStatusRequest.encode(message.update_block_status, writer.uint32(938).fork()).ldelim();
        }
        if (message.ban_user !== undefined) {
            exports.BanUserRequest.encode(message.ban_user, writer.uint32(946).fork())
                .ldelim();
        }
        if (message.get_rtc_token !== undefined) {
            exports.GetRtcTokenRequest.encode(message.get_rtc_token, writer.uint32(954).fork()).ldelim();
        }
        if (message.cancel_voice_channel !== undefined) {
            exports.CancelVoiceChannelRequest.encode(message.cancel_voice_channel, writer.uint32(962).fork()).ldelim();
        }
        if (message.reject_voice_channel !== undefined) {
            exports.RejectVoiceChannelRequest.encode(message.reject_voice_channel, writer.uint32(970).fork()).ldelim();
        }
        if (message.get_channel_list_header !== undefined) {
            exports.GetChannelListHeaderRequest.encode(message.get_channel_list_header, writer.uint32(978).fork()).ldelim();
        }
        if (message.close_channel_list_header !== undefined) {
            exports.CloseChannelListHeaderRequest.encode(message.close_channel_list_header, writer.uint32(986).fork()).ldelim();
        }
        if (message.delete_message !== undefined) {
            exports.DeleteMessageRequest.encode(message.delete_message, writer.uint32(994).fork()).ldelim();
        }
        if (message.send_persistent_menu_postback !== undefined) {
            exports.SendPersistentMenuPostbackRequest.encode(message.send_persistent_menu_postback, writer.uint32(1002).fork())
                .ldelim();
        }
        if (message.get_auto_reply_metadata !== undefined) {
            exports.GetAutoReplyMetadataRequest.encode(message.get_auto_reply_metadata, writer.uint32(1010).fork()).ldelim();
        }
        if (message.update_auto_reply_metadata !== undefined) {
            exports.UpdateAutoReplyMetadataRequest.encode(message.update_auto_reply_metadata, writer.uint32(1018).fork()).ldelim();
        }
        if (message.list_auto_replies !== undefined) {
            exports.ListAutoRepliesRequest.encode(message.list_auto_replies, writer.uint32(1026).fork()).ldelim();
        }
        if (message.create_auto_reply !== undefined) {
            exports.CreateAutoReplyRequest.encode(message.create_auto_reply, writer.uint32(1034).fork()).ldelim();
        }
        if (message.get_auto_reply !== undefined) {
            exports.GetAutoReplyRequest.encode(message.get_auto_reply, writer.uint32(1042).fork()).ldelim();
        }
        if (message.update_auto_reply !== undefined) {
            exports.UpdateAutoReplyRequest.encode(message.update_auto_reply, writer.uint32(1050).fork()).ldelim();
        }
        if (message.delete_auto_reply !== undefined) {
            exports.DeleteAutoReplyRequest.encode(message.delete_auto_reply, writer.uint32(1058).fork()).ldelim();
        }
        if (message.create_announcement !== undefined) {
            exports.CreateAnnouncementRequest.encode(message.create_announcement, writer.uint32(1066).fork()).ldelim();
        }
        if (message.delete_announcement !== undefined) {
            exports.DeleteAnnouncementRequest.encode(message.delete_announcement, writer.uint32(1074).fork()).ldelim();
        }
        if (message.set_reaction !== undefined) {
            exports.SetReactionRequest.encode(message.set_reaction, writer.uint32(1082).fork()).ldelim();
        }
        if (message.list_reaction !== undefined) {
            exports.ListReactionRequest.encode(message.list_reaction, writer.uint32(1090).fork()).ldelim();
        }
        if (message.get_filters !== undefined) {
            exports.GetFiltersRequest.encode(message.get_filters, writer.uint32(1098).fork())
                .ldelim();
        }
        if (message.get_member !== undefined) {
            exports.GetMemberRequest.encode(message.get_member, writer.uint32(1130).fork())
                .ldelim();
        }
        if (message.get_members !== undefined) {
            exports.GetMembersRequest.encode(message.get_members, writer.uint32(1138).fork())
                .ldelim();
        }
        if (message.search_members !== undefined) {
            exports.SearchMembersRequest.encode(message.search_members, writer.uint32(1146).fork()).ldelim();
        }
        if (message.send_button_postback !== undefined) {
            exports.SendButtonPostbackRequest.encode(message.send_button_postback, writer.uint32(1202).fork()).ldelim();
        }
        if (message.ack_event !== undefined) {
            exports.AckEventRequest.encode(message.ack_event, writer.uint32(1210).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    const entry2 = exports.Request_PropsEntry.decode(reader, reader.uint32());
                    if (entry2.value !== undefined) {
                        message.props[entry2.key] = entry2.value;
                    }
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.echo = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.send_message = exports.SendMessageRequest.decode(reader, reader.uint32());
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.get_channels = exports.GetChannelsRequest.decode(reader, reader.uint32());
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.get_messages = exports.GetMessagesRequest.decode(reader, reader.uint32());
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.create_channel = exports.CreateChannelRequest.decode(reader, reader.uint32());
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.mark_as_read = exports.MarkAsReadRequest.decode(reader, reader.uint32());
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.leave_channel = exports.LeaveChannelRequest.decode(reader, reader.uint32());
                    continue;
                case 106:
                    if (tag !== 850) {
                        break;
                    }
                    message.update_user_channel = exports.UpdateUserChannelRequest.decode(reader, reader.uint32());
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.get_channel = exports.GetChannelRequest.decode(reader, reader.uint32());
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.get_seller_channels = exports.GetSellerChannelsRequest.decode(reader, reader.uint32());
                    continue;
                case 109:
                    if (tag !== 874) {
                        break;
                    }
                    message.get_unread_count = exports.GetUnreadCountRequest.decode(reader, reader.uint32());
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.create_promise = exports.CreatePromiseRequest.decode(reader, reader.uint32());
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.update_promise = exports.UpdatePromiseRequest.decode(reader, reader.uint32());
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.delete_promise = exports.DeletePromiseRequest.decode(reader, reader.uint32());
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.get_biz_accounts = exports.GetBizAccountsRequest.decode(reader, reader.uint32());
                    continue;
                case 114:
                    if (tag !== 914) {
                        break;
                    }
                    message.get_biz_account = exports.GetBizAccountRequest.decode(reader, reader.uint32());
                    continue;
                case 115:
                    if (tag !== 922) {
                        break;
                    }
                    message.get_stickers = exports.GetStickersRequest.decode(reader, reader.uint32());
                    continue;
                case 116:
                    if (tag !== 930) {
                        break;
                    }
                    message.get_safe_number = exports.GetSafeNumberRequest.decode(reader, reader.uint32());
                    continue;
                case 117:
                    if (tag !== 938) {
                        break;
                    }
                    message.update_block_status = exports.UpdateBlockStatusRequest.decode(reader, reader.uint32());
                    continue;
                case 118:
                    if (tag !== 946) {
                        break;
                    }
                    message.ban_user = exports.BanUserRequest.decode(reader, reader.uint32());
                    continue;
                case 119:
                    if (tag !== 954) {
                        break;
                    }
                    message.get_rtc_token = exports.GetRtcTokenRequest.decode(reader, reader.uint32());
                    continue;
                case 120:
                    if (tag !== 962) {
                        break;
                    }
                    message.cancel_voice_channel = exports.CancelVoiceChannelRequest.decode(reader, reader.uint32());
                    continue;
                case 121:
                    if (tag !== 970) {
                        break;
                    }
                    message.reject_voice_channel = exports.RejectVoiceChannelRequest.decode(reader, reader.uint32());
                    continue;
                case 122:
                    if (tag !== 978) {
                        break;
                    }
                    message.get_channel_list_header = exports.GetChannelListHeaderRequest.decode(reader, reader.uint32());
                    continue;
                case 123:
                    if (tag !== 986) {
                        break;
                    }
                    message.close_channel_list_header = exports.CloseChannelListHeaderRequest
                        .decode(reader, reader.uint32());
                    continue;
                case 124:
                    if (tag !== 994) {
                        break;
                    }
                    message.delete_message = exports.DeleteMessageRequest.decode(reader, reader.uint32());
                    continue;
                case 125:
                    if (tag !== 1002) {
                        break;
                    }
                    message.send_persistent_menu_postback =
                        exports.SendPersistentMenuPostbackRequest.decode(reader, reader.uint32());
                    continue;
                case 126:
                    if (tag !== 1010) {
                        break;
                    }
                    message.get_auto_reply_metadata = exports.GetAutoReplyMetadataRequest.decode(reader, reader.uint32());
                    continue;
                case 127:
                    if (tag !== 1018) {
                        break;
                    }
                    message.update_auto_reply_metadata = exports.UpdateAutoReplyMetadataRequest
                        .decode(reader, reader.uint32());
                    continue;
                case 128:
                    if (tag !== 1026) {
                        break;
                    }
                    message.list_auto_replies = exports.ListAutoRepliesRequest.decode(reader, reader.uint32());
                    continue;
                case 129:
                    if (tag !== 1034) {
                        break;
                    }
                    message.create_auto_reply = exports.CreateAutoReplyRequest.decode(reader, reader.uint32());
                    continue;
                case 130:
                    if (tag !== 1042) {
                        break;
                    }
                    message.get_auto_reply = exports.GetAutoReplyRequest.decode(reader, reader.uint32());
                    continue;
                case 131:
                    if (tag !== 1050) {
                        break;
                    }
                    message.update_auto_reply = exports.UpdateAutoReplyRequest.decode(reader, reader.uint32());
                    continue;
                case 132:
                    if (tag !== 1058) {
                        break;
                    }
                    message.delete_auto_reply = exports.DeleteAutoReplyRequest.decode(reader, reader.uint32());
                    continue;
                case 133:
                    if (tag !== 1066) {
                        break;
                    }
                    message.create_announcement = exports.CreateAnnouncementRequest.decode(reader, reader.uint32());
                    continue;
                case 134:
                    if (tag !== 1074) {
                        break;
                    }
                    message.delete_announcement = exports.DeleteAnnouncementRequest.decode(reader, reader.uint32());
                    continue;
                case 135:
                    if (tag !== 1082) {
                        break;
                    }
                    message.set_reaction = exports.SetReactionRequest.decode(reader, reader.uint32());
                    continue;
                case 136:
                    if (tag !== 1090) {
                        break;
                    }
                    message.list_reaction = exports.ListReactionRequest.decode(reader, reader.uint32());
                    continue;
                case 137:
                    if (tag !== 1098) {
                        break;
                    }
                    message.get_filters = exports.GetFiltersRequest.decode(reader, reader.uint32());
                    continue;
                case 141:
                    if (tag !== 1130) {
                        break;
                    }
                    message.get_member = exports.GetMemberRequest.decode(reader, reader.uint32());
                    continue;
                case 142:
                    if (tag !== 1138) {
                        break;
                    }
                    message.get_members = exports.GetMembersRequest.decode(reader, reader.uint32());
                    continue;
                case 143:
                    if (tag !== 1146) {
                        break;
                    }
                    message.search_members = exports.SearchMembersRequest.decode(reader, reader.uint32());
                    continue;
                case 150:
                    if (tag !== 1202) {
                        break;
                    }
                    message.send_button_postback = exports.SendButtonPostbackRequest.decode(reader, reader.uint32());
                    continue;
                case 151:
                    if (tag !== 1210) {
                        break;
                    }
                    message.ack_event = exports.AckEventRequest.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            props: isObject(object.props)
                ? Object.entries(object.props).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            echo: isSet(object.echo) ? globalThis.String(object.echo) : "",
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            send_message: isSet(object.send_message)
                ? exports.SendMessageRequest.fromJSON(object.send_message)
                : undefined,
            get_channels: isSet(object.get_channels)
                ? exports.GetChannelsRequest.fromJSON(object.get_channels)
                : undefined,
            get_messages: isSet(object.get_messages)
                ? exports.GetMessagesRequest.fromJSON(object.get_messages)
                : undefined,
            create_channel: isSet(object.create_channel)
                ? exports.CreateChannelRequest.fromJSON(object.create_channel)
                : undefined,
            mark_as_read: isSet(object.mark_as_read)
                ? exports.MarkAsReadRequest.fromJSON(object.mark_as_read)
                : undefined,
            leave_channel: isSet(object.leave_channel)
                ? exports.LeaveChannelRequest.fromJSON(object.leave_channel)
                : undefined,
            update_user_channel: isSet(object.update_user_channel)
                ? exports.UpdateUserChannelRequest.fromJSON(object.update_user_channel)
                : undefined,
            get_channel: isSet(object.get_channel)
                ? exports.GetChannelRequest.fromJSON(object.get_channel)
                : undefined,
            get_seller_channels: isSet(object.get_seller_channels)
                ? exports.GetSellerChannelsRequest.fromJSON(object.get_seller_channels)
                : undefined,
            get_unread_count: isSet(object.get_unread_count)
                ? exports.GetUnreadCountRequest.fromJSON(object.get_unread_count)
                : undefined,
            create_promise: isSet(object.create_promise)
                ? exports.CreatePromiseRequest.fromJSON(object.create_promise)
                : undefined,
            update_promise: isSet(object.update_promise)
                ? exports.UpdatePromiseRequest.fromJSON(object.update_promise)
                : undefined,
            delete_promise: isSet(object.delete_promise)
                ? exports.DeletePromiseRequest.fromJSON(object.delete_promise)
                : undefined,
            get_biz_accounts: isSet(object.get_biz_accounts)
                ? exports.GetBizAccountsRequest.fromJSON(object.get_biz_accounts)
                : undefined,
            get_biz_account: isSet(object.get_biz_account)
                ? exports.GetBizAccountRequest.fromJSON(object.get_biz_account)
                : undefined,
            get_stickers: isSet(object.get_stickers)
                ? exports.GetStickersRequest.fromJSON(object.get_stickers)
                : undefined,
            get_safe_number: isSet(object.get_safe_number)
                ? exports.GetSafeNumberRequest.fromJSON(object.get_safe_number)
                : undefined,
            update_block_status: isSet(object.update_block_status)
                ? exports.UpdateBlockStatusRequest.fromJSON(object.update_block_status)
                : undefined,
            ban_user: isSet(object.ban_user)
                ? exports.BanUserRequest.fromJSON(object.ban_user)
                : undefined,
            get_rtc_token: isSet(object.get_rtc_token)
                ? exports.GetRtcTokenRequest.fromJSON(object.get_rtc_token)
                : undefined,
            cancel_voice_channel: isSet(object.cancel_voice_channel)
                ? exports.CancelVoiceChannelRequest.fromJSON(object.cancel_voice_channel)
                : undefined,
            reject_voice_channel: isSet(object.reject_voice_channel)
                ? exports.RejectVoiceChannelRequest.fromJSON(object.reject_voice_channel)
                : undefined,
            get_channel_list_header: isSet(object.get_channel_list_header)
                ? exports.GetChannelListHeaderRequest.fromJSON(object.get_channel_list_header)
                : undefined,
            close_channel_list_header: isSet(object.close_channel_list_header)
                ? exports.CloseChannelListHeaderRequest.fromJSON(object.close_channel_list_header)
                : undefined,
            delete_message: isSet(object.delete_message)
                ? exports.DeleteMessageRequest.fromJSON(object.delete_message)
                : undefined,
            send_persistent_menu_postback: isSet(object.send_persistent_menu_postback)
                ? exports.SendPersistentMenuPostbackRequest.fromJSON(object.send_persistent_menu_postback)
                : undefined,
            get_auto_reply_metadata: isSet(object.get_auto_reply_metadata)
                ? exports.GetAutoReplyMetadataRequest.fromJSON(object.get_auto_reply_metadata)
                : undefined,
            update_auto_reply_metadata: isSet(object.update_auto_reply_metadata)
                ? exports.UpdateAutoReplyMetadataRequest.fromJSON(object.update_auto_reply_metadata)
                : undefined,
            list_auto_replies: isSet(object.list_auto_replies)
                ? exports.ListAutoRepliesRequest.fromJSON(object.list_auto_replies)
                : undefined,
            create_auto_reply: isSet(object.create_auto_reply)
                ? exports.CreateAutoReplyRequest.fromJSON(object.create_auto_reply)
                : undefined,
            get_auto_reply: isSet(object.get_auto_reply)
                ? exports.GetAutoReplyRequest.fromJSON(object.get_auto_reply)
                : undefined,
            update_auto_reply: isSet(object.update_auto_reply)
                ? exports.UpdateAutoReplyRequest.fromJSON(object.update_auto_reply)
                : undefined,
            delete_auto_reply: isSet(object.delete_auto_reply)
                ? exports.DeleteAutoReplyRequest.fromJSON(object.delete_auto_reply)
                : undefined,
            create_announcement: isSet(object.create_announcement)
                ? exports.CreateAnnouncementRequest.fromJSON(object.create_announcement)
                : undefined,
            delete_announcement: isSet(object.delete_announcement)
                ? exports.DeleteAnnouncementRequest.fromJSON(object.delete_announcement)
                : undefined,
            set_reaction: isSet(object.set_reaction)
                ? exports.SetReactionRequest.fromJSON(object.set_reaction)
                : undefined,
            list_reaction: isSet(object.list_reaction)
                ? exports.ListReactionRequest.fromJSON(object.list_reaction)
                : undefined,
            get_filters: isSet(object.get_filters)
                ? exports.GetFiltersRequest.fromJSON(object.get_filters)
                : undefined,
            get_member: isSet(object.get_member)
                ? exports.GetMemberRequest.fromJSON(object.get_member)
                : undefined,
            get_members: isSet(object.get_members)
                ? exports.GetMembersRequest.fromJSON(object.get_members)
                : undefined,
            search_members: isSet(object.search_members)
                ? exports.SearchMembersRequest.fromJSON(object.search_members)
                : undefined,
            send_button_postback: isSet(object.send_button_postback)
                ? exports.SendButtonPostbackRequest.fromJSON(object.send_button_postback)
                : undefined,
            ack_event: isSet(object.ack_event)
                ? exports.AckEventRequest.fromJSON(object.ack_event)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.props) {
            const entries = Object.entries(message.props);
            if (entries.length > 0) {
                obj.props = {};
                entries.forEach(([k, v]) => {
                    obj.props[k] = v;
                });
            }
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.echo !== "") {
            obj.echo = message.echo;
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.send_message !== undefined) {
            obj.send_message = exports.SendMessageRequest.toJSON(message.send_message);
        }
        if (message.get_channels !== undefined) {
            obj.get_channels = exports.GetChannelsRequest.toJSON(message.get_channels);
        }
        if (message.get_messages !== undefined) {
            obj.get_messages = exports.GetMessagesRequest.toJSON(message.get_messages);
        }
        if (message.create_channel !== undefined) {
            obj.create_channel = exports.CreateChannelRequest.toJSON(message.create_channel);
        }
        if (message.mark_as_read !== undefined) {
            obj.mark_as_read = exports.MarkAsReadRequest.toJSON(message.mark_as_read);
        }
        if (message.leave_channel !== undefined) {
            obj.leave_channel = exports.LeaveChannelRequest.toJSON(message.leave_channel);
        }
        if (message.update_user_channel !== undefined) {
            obj.update_user_channel = exports.UpdateUserChannelRequest.toJSON(message.update_user_channel);
        }
        if (message.get_channel !== undefined) {
            obj.get_channel = exports.GetChannelRequest.toJSON(message.get_channel);
        }
        if (message.get_seller_channels !== undefined) {
            obj.get_seller_channels = exports.GetSellerChannelsRequest.toJSON(message.get_seller_channels);
        }
        if (message.get_unread_count !== undefined) {
            obj.get_unread_count = exports.GetUnreadCountRequest.toJSON(message.get_unread_count);
        }
        if (message.create_promise !== undefined) {
            obj.create_promise = exports.CreatePromiseRequest.toJSON(message.create_promise);
        }
        if (message.update_promise !== undefined) {
            obj.update_promise = exports.UpdatePromiseRequest.toJSON(message.update_promise);
        }
        if (message.delete_promise !== undefined) {
            obj.delete_promise = exports.DeletePromiseRequest.toJSON(message.delete_promise);
        }
        if (message.get_biz_accounts !== undefined) {
            obj.get_biz_accounts = exports.GetBizAccountsRequest.toJSON(message.get_biz_accounts);
        }
        if (message.get_biz_account !== undefined) {
            obj.get_biz_account = exports.GetBizAccountRequest.toJSON(message.get_biz_account);
        }
        if (message.get_stickers !== undefined) {
            obj.get_stickers = exports.GetStickersRequest.toJSON(message.get_stickers);
        }
        if (message.get_safe_number !== undefined) {
            obj.get_safe_number = exports.GetSafeNumberRequest.toJSON(message.get_safe_number);
        }
        if (message.update_block_status !== undefined) {
            obj.update_block_status = exports.UpdateBlockStatusRequest.toJSON(message.update_block_status);
        }
        if (message.ban_user !== undefined) {
            obj.ban_user = exports.BanUserRequest.toJSON(message.ban_user);
        }
        if (message.get_rtc_token !== undefined) {
            obj.get_rtc_token = exports.GetRtcTokenRequest.toJSON(message.get_rtc_token);
        }
        if (message.cancel_voice_channel !== undefined) {
            obj.cancel_voice_channel = exports.CancelVoiceChannelRequest.toJSON(message.cancel_voice_channel);
        }
        if (message.reject_voice_channel !== undefined) {
            obj.reject_voice_channel = exports.RejectVoiceChannelRequest.toJSON(message.reject_voice_channel);
        }
        if (message.get_channel_list_header !== undefined) {
            obj.get_channel_list_header = exports.GetChannelListHeaderRequest.toJSON(message.get_channel_list_header);
        }
        if (message.close_channel_list_header !== undefined) {
            obj.close_channel_list_header = exports.CloseChannelListHeaderRequest.toJSON(message.close_channel_list_header);
        }
        if (message.delete_message !== undefined) {
            obj.delete_message = exports.DeleteMessageRequest.toJSON(message.delete_message);
        }
        if (message.send_persistent_menu_postback !== undefined) {
            obj.send_persistent_menu_postback = exports.SendPersistentMenuPostbackRequest
                .toJSON(message.send_persistent_menu_postback);
        }
        if (message.get_auto_reply_metadata !== undefined) {
            obj.get_auto_reply_metadata = exports.GetAutoReplyMetadataRequest.toJSON(message.get_auto_reply_metadata);
        }
        if (message.update_auto_reply_metadata !== undefined) {
            obj.update_auto_reply_metadata = exports.UpdateAutoReplyMetadataRequest.toJSON(message.update_auto_reply_metadata);
        }
        if (message.list_auto_replies !== undefined) {
            obj.list_auto_replies = exports.ListAutoRepliesRequest.toJSON(message.list_auto_replies);
        }
        if (message.create_auto_reply !== undefined) {
            obj.create_auto_reply = exports.CreateAutoReplyRequest.toJSON(message.create_auto_reply);
        }
        if (message.get_auto_reply !== undefined) {
            obj.get_auto_reply = exports.GetAutoReplyRequest.toJSON(message.get_auto_reply);
        }
        if (message.update_auto_reply !== undefined) {
            obj.update_auto_reply = exports.UpdateAutoReplyRequest.toJSON(message.update_auto_reply);
        }
        if (message.delete_auto_reply !== undefined) {
            obj.delete_auto_reply = exports.DeleteAutoReplyRequest.toJSON(message.delete_auto_reply);
        }
        if (message.create_announcement !== undefined) {
            obj.create_announcement = exports.CreateAnnouncementRequest.toJSON(message.create_announcement);
        }
        if (message.delete_announcement !== undefined) {
            obj.delete_announcement = exports.DeleteAnnouncementRequest.toJSON(message.delete_announcement);
        }
        if (message.set_reaction !== undefined) {
            obj.set_reaction = exports.SetReactionRequest.toJSON(message.set_reaction);
        }
        if (message.list_reaction !== undefined) {
            obj.list_reaction = exports.ListReactionRequest.toJSON(message.list_reaction);
        }
        if (message.get_filters !== undefined) {
            obj.get_filters = exports.GetFiltersRequest.toJSON(message.get_filters);
        }
        if (message.get_member !== undefined) {
            obj.get_member = exports.GetMemberRequest.toJSON(message.get_member);
        }
        if (message.get_members !== undefined) {
            obj.get_members = exports.GetMembersRequest.toJSON(message.get_members);
        }
        if (message.search_members !== undefined) {
            obj.search_members = exports.SearchMembersRequest.toJSON(message.search_members);
        }
        if (message.send_button_postback !== undefined) {
            obj.send_button_postback = exports.SendButtonPostbackRequest.toJSON(message.send_button_postback);
        }
        if (message.ack_event !== undefined) {
            obj.ack_event = exports.AckEventRequest.toJSON(message.ack_event);
        }
        return obj;
    },
    create(base) {
        return exports.Request.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseRequest();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.props = Object.entries((_b = object.props) !== null && _b !== void 0 ? _b : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.id = (_c = object.id) !== null && _c !== void 0 ? _c : "";
        message.echo = (_d = object.echo) !== null && _d !== void 0 ? _d : "";
        message.biz_account_id = (_e = object.biz_account_id) !== null && _e !== void 0 ? _e : "0";
        message.send_message =
            (object.send_message !== undefined && object.send_message !== null)
                ? exports.SendMessageRequest.fromPartial(object.send_message)
                : undefined;
        message.get_channels =
            (object.get_channels !== undefined && object.get_channels !== null)
                ? exports.GetChannelsRequest.fromPartial(object.get_channels)
                : undefined;
        message.get_messages =
            (object.get_messages !== undefined && object.get_messages !== null)
                ? exports.GetMessagesRequest.fromPartial(object.get_messages)
                : undefined;
        message.create_channel =
            (object.create_channel !== undefined && object.create_channel !== null)
                ? exports.CreateChannelRequest.fromPartial(object.create_channel)
                : undefined;
        message.mark_as_read =
            (object.mark_as_read !== undefined && object.mark_as_read !== null)
                ? exports.MarkAsReadRequest.fromPartial(object.mark_as_read)
                : undefined;
        message.leave_channel =
            (object.leave_channel !== undefined && object.leave_channel !== null)
                ? exports.LeaveChannelRequest.fromPartial(object.leave_channel)
                : undefined;
        message.update_user_channel = (object.update_user_channel !== undefined &&
            object.update_user_channel !== null)
            ? exports.UpdateUserChannelRequest.fromPartial(object.update_user_channel)
            : undefined;
        message.get_channel =
            (object.get_channel !== undefined && object.get_channel !== null)
                ? exports.GetChannelRequest.fromPartial(object.get_channel)
                : undefined;
        message.get_seller_channels = (object.get_seller_channels !== undefined &&
            object.get_seller_channels !== null)
            ? exports.GetSellerChannelsRequest.fromPartial(object.get_seller_channels)
            : undefined;
        message.get_unread_count = (object.get_unread_count !== undefined &&
            object.get_unread_count !== null)
            ? exports.GetUnreadCountRequest.fromPartial(object.get_unread_count)
            : undefined;
        message.create_promise =
            (object.create_promise !== undefined && object.create_promise !== null)
                ? exports.CreatePromiseRequest.fromPartial(object.create_promise)
                : undefined;
        message.update_promise =
            (object.update_promise !== undefined && object.update_promise !== null)
                ? exports.UpdatePromiseRequest.fromPartial(object.update_promise)
                : undefined;
        message.delete_promise =
            (object.delete_promise !== undefined && object.delete_promise !== null)
                ? exports.DeletePromiseRequest.fromPartial(object.delete_promise)
                : undefined;
        message.get_biz_accounts = (object.get_biz_accounts !== undefined &&
            object.get_biz_accounts !== null)
            ? exports.GetBizAccountsRequest.fromPartial(object.get_biz_accounts)
            : undefined;
        message.get_biz_account =
            (object.get_biz_account !== undefined && object.get_biz_account !== null)
                ? exports.GetBizAccountRequest.fromPartial(object.get_biz_account)
                : undefined;
        message.get_stickers =
            (object.get_stickers !== undefined && object.get_stickers !== null)
                ? exports.GetStickersRequest.fromPartial(object.get_stickers)
                : undefined;
        message.get_safe_number =
            (object.get_safe_number !== undefined && object.get_safe_number !== null)
                ? exports.GetSafeNumberRequest.fromPartial(object.get_safe_number)
                : undefined;
        message.update_block_status = (object.update_block_status !== undefined &&
            object.update_block_status !== null)
            ? exports.UpdateBlockStatusRequest.fromPartial(object.update_block_status)
            : undefined;
        message.ban_user =
            (object.ban_user !== undefined && object.ban_user !== null)
                ? exports.BanUserRequest.fromPartial(object.ban_user)
                : undefined;
        message.get_rtc_token =
            (object.get_rtc_token !== undefined && object.get_rtc_token !== null)
                ? exports.GetRtcTokenRequest.fromPartial(object.get_rtc_token)
                : undefined;
        message.cancel_voice_channel = (object.cancel_voice_channel !== undefined &&
            object.cancel_voice_channel !== null)
            ? exports.CancelVoiceChannelRequest.fromPartial(object.cancel_voice_channel)
            : undefined;
        message.reject_voice_channel = (object.reject_voice_channel !== undefined &&
            object.reject_voice_channel !== null)
            ? exports.RejectVoiceChannelRequest.fromPartial(object.reject_voice_channel)
            : undefined;
        message.get_channel_list_header =
            (object.get_channel_list_header !== undefined &&
                object.get_channel_list_header !== null)
                ? exports.GetChannelListHeaderRequest.fromPartial(object.get_channel_list_header)
                : undefined;
        message.close_channel_list_header =
            (object.close_channel_list_header !== undefined &&
                object.close_channel_list_header !== null)
                ? exports.CloseChannelListHeaderRequest.fromPartial(object.close_channel_list_header)
                : undefined;
        message.delete_message =
            (object.delete_message !== undefined && object.delete_message !== null)
                ? exports.DeleteMessageRequest.fromPartial(object.delete_message)
                : undefined;
        message.send_persistent_menu_postback =
            (object.send_persistent_menu_postback !== undefined &&
                object.send_persistent_menu_postback !== null)
                ? exports.SendPersistentMenuPostbackRequest.fromPartial(object.send_persistent_menu_postback)
                : undefined;
        message.get_auto_reply_metadata =
            (object.get_auto_reply_metadata !== undefined &&
                object.get_auto_reply_metadata !== null)
                ? exports.GetAutoReplyMetadataRequest.fromPartial(object.get_auto_reply_metadata)
                : undefined;
        message.update_auto_reply_metadata =
            (object.update_auto_reply_metadata !== undefined &&
                object.update_auto_reply_metadata !== null)
                ? exports.UpdateAutoReplyMetadataRequest.fromPartial(object.update_auto_reply_metadata)
                : undefined;
        message.list_auto_replies = (object.list_auto_replies !== undefined &&
            object.list_auto_replies !== null)
            ? exports.ListAutoRepliesRequest.fromPartial(object.list_auto_replies)
            : undefined;
        message.create_auto_reply = (object.create_auto_reply !== undefined &&
            object.create_auto_reply !== null)
            ? exports.CreateAutoReplyRequest.fromPartial(object.create_auto_reply)
            : undefined;
        message.get_auto_reply =
            (object.get_auto_reply !== undefined && object.get_auto_reply !== null)
                ? exports.GetAutoReplyRequest.fromPartial(object.get_auto_reply)
                : undefined;
        message.update_auto_reply = (object.update_auto_reply !== undefined &&
            object.update_auto_reply !== null)
            ? exports.UpdateAutoReplyRequest.fromPartial(object.update_auto_reply)
            : undefined;
        message.delete_auto_reply = (object.delete_auto_reply !== undefined &&
            object.delete_auto_reply !== null)
            ? exports.DeleteAutoReplyRequest.fromPartial(object.delete_auto_reply)
            : undefined;
        message.create_announcement = (object.create_announcement !== undefined &&
            object.create_announcement !== null)
            ? exports.CreateAnnouncementRequest.fromPartial(object.create_announcement)
            : undefined;
        message.delete_announcement = (object.delete_announcement !== undefined &&
            object.delete_announcement !== null)
            ? exports.DeleteAnnouncementRequest.fromPartial(object.delete_announcement)
            : undefined;
        message.set_reaction =
            (object.set_reaction !== undefined && object.set_reaction !== null)
                ? exports.SetReactionRequest.fromPartial(object.set_reaction)
                : undefined;
        message.list_reaction =
            (object.list_reaction !== undefined && object.list_reaction !== null)
                ? exports.ListReactionRequest.fromPartial(object.list_reaction)
                : undefined;
        message.get_filters =
            (object.get_filters !== undefined && object.get_filters !== null)
                ? exports.GetFiltersRequest.fromPartial(object.get_filters)
                : undefined;
        message.get_member =
            (object.get_member !== undefined && object.get_member !== null)
                ? exports.GetMemberRequest.fromPartial(object.get_member)
                : undefined;
        message.get_members =
            (object.get_members !== undefined && object.get_members !== null)
                ? exports.GetMembersRequest.fromPartial(object.get_members)
                : undefined;
        message.search_members =
            (object.search_members !== undefined && object.search_members !== null)
                ? exports.SearchMembersRequest.fromPartial(object.search_members)
                : undefined;
        message.send_button_postback = (object.send_button_postback !== undefined &&
            object.send_button_postback !== null)
            ? exports.SendButtonPostbackRequest.fromPartial(object.send_button_postback)
            : undefined;
        message.ack_event =
            (object.ack_event !== undefined && object.ack_event !== null)
                ? exports.AckEventRequest.fromPartial(object.ack_event)
                : undefined;
        return message;
    },
};
function createBaseRequest_PropsEntry() {
    return { key: "", value: "" };
}
exports.Request_PropsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRequest_PropsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.Request_PropsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRequest_PropsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseStatusAction() {
    return { text: "", target_uri: "" };
}
exports.StatusAction = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.text !== "") {
            writer.uint32(10).string(message.text);
        }
        if (message.target_uri !== "") {
            writer.uint32(18).string(message.target_uri);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStatusAction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.target_uri = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            target_uri: isSet(object.target_uri)
                ? globalThis.String(object.target_uri)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.target_uri !== "") {
            obj.target_uri = message.target_uri;
        }
        return obj;
    },
    create(base) {
        return exports.StatusAction.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseStatusAction();
        message.text = (_a = object.text) !== null && _a !== void 0 ? _a : "";
        message.target_uri = (_b = object.target_uri) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseResponse() {
    return {
        name: "",
        status: Status.UNKNOWN,
        id: "",
        echo: "",
        biz_account_id: "0",
        status_message: "",
        status_action: undefined,
        send_message: undefined,
        get_channels: undefined,
        get_messages: undefined,
        create_channel: undefined,
        mark_as_read: undefined,
        leave_channel: undefined,
        update_user_channel: undefined,
        get_channel: undefined,
        get_seller_channels: undefined,
        get_unread_count: undefined,
        create_promise: undefined,
        update_promise: undefined,
        delete_promise: undefined,
        get_biz_accounts: undefined,
        get_biz_account: undefined,
        get_stickers: undefined,
        get_safe_number: undefined,
        update_block_status: undefined,
        ban_user: undefined,
        get_rtc_token: undefined,
        cancel_voice_channel: undefined,
        reject_voice_channel: undefined,
        get_channel_list_header: undefined,
        close_channel_list_header: undefined,
        delete_message: undefined,
        send_persistent_menu_postback: undefined,
        get_auto_reply_metadata: undefined,
        update_auto_reply_metadata: undefined,
        list_auto_replies: undefined,
        create_auto_reply: undefined,
        get_auto_reply: undefined,
        update_auto_reply: undefined,
        delete_auto_reply: undefined,
        create_announcement: undefined,
        delete_announcement: undefined,
        set_reaction: undefined,
        list_reaction: undefined,
        get_filters: undefined,
        get_member: undefined,
        get_members: undefined,
        search_members: undefined,
        send_button_postback: undefined,
        new_message: undefined,
        read_message: undefined,
        join_member: undefined,
        leave_member: undefined,
        renew_channel: undefined,
        update_bubble_group: undefined,
        update_message: undefined,
        join_voice_channel: undefined,
        terminate_voice_channel: undefined,
    };
}
exports.Response = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.status !== Status.UNKNOWN) {
            writer.uint32(16).int32(statusToNumber(message.status));
        }
        if (message.id !== "") {
            writer.uint32(26).string(message.id);
        }
        if (message.echo !== "") {
            writer.uint32(34).string(message.echo);
        }
        if (message.biz_account_id !== "0") {
            writer.uint32(40).int64(message.biz_account_id);
        }
        if (message.status_message !== "") {
            writer.uint32(50).string(message.status_message);
        }
        if (message.status_action !== undefined) {
            exports.StatusAction.encode(message.status_action, writer.uint32(58).fork())
                .ldelim();
        }
        if (message.send_message !== undefined) {
            exports.SendMessageResponse.encode(message.send_message, writer.uint32(802).fork()).ldelim();
        }
        if (message.get_channels !== undefined) {
            exports.GetChannelsResponse.encode(message.get_channels, writer.uint32(810).fork()).ldelim();
        }
        if (message.get_messages !== undefined) {
            exports.GetMessagesResponse.encode(message.get_messages, writer.uint32(818).fork()).ldelim();
        }
        if (message.create_channel !== undefined) {
            exports.CreateChannelResponse.encode(message.create_channel, writer.uint32(826).fork()).ldelim();
        }
        if (message.mark_as_read !== undefined) {
            exports.MarkAsReadResponse.encode(message.mark_as_read, writer.uint32(834).fork())
                .ldelim();
        }
        if (message.leave_channel !== undefined) {
            exports.LeaveChannelResponse.encode(message.leave_channel, writer.uint32(842).fork()).ldelim();
        }
        if (message.update_user_channel !== undefined) {
            exports.UpdateUserChannelResponse.encode(message.update_user_channel, writer.uint32(850).fork()).ldelim();
        }
        if (message.get_channel !== undefined) {
            exports.GetChannelResponse.encode(message.get_channel, writer.uint32(858).fork())
                .ldelim();
        }
        if (message.get_seller_channels !== undefined) {
            exports.GetSellerChannelsResponse.encode(message.get_seller_channels, writer.uint32(866).fork()).ldelim();
        }
        if (message.get_unread_count !== undefined) {
            exports.GetUnreadCountResponse.encode(message.get_unread_count, writer.uint32(874).fork()).ldelim();
        }
        if (message.create_promise !== undefined) {
            exports.CreatePromiseResponse.encode(message.create_promise, writer.uint32(882).fork()).ldelim();
        }
        if (message.update_promise !== undefined) {
            exports.UpdatePromiseResponse.encode(message.update_promise, writer.uint32(890).fork()).ldelim();
        }
        if (message.delete_promise !== undefined) {
            exports.DeletePromiseResponse.encode(message.delete_promise, writer.uint32(898).fork()).ldelim();
        }
        if (message.get_biz_accounts !== undefined) {
            exports.GetBizAccountsResponse.encode(message.get_biz_accounts, writer.uint32(906).fork()).ldelim();
        }
        if (message.get_biz_account !== undefined) {
            exports.GetBizAccountResponse.encode(message.get_biz_account, writer.uint32(914).fork()).ldelim();
        }
        if (message.get_stickers !== undefined) {
            exports.GetStickersResponse.encode(message.get_stickers, writer.uint32(922).fork()).ldelim();
        }
        if (message.get_safe_number !== undefined) {
            exports.GetSafeNumberResponse.encode(message.get_safe_number, writer.uint32(930).fork()).ldelim();
        }
        if (message.update_block_status !== undefined) {
            exports.UpdateBlockStatusResponse.encode(message.update_block_status, writer.uint32(938).fork()).ldelim();
        }
        if (message.ban_user !== undefined) {
            exports.BanUserResponse.encode(message.ban_user, writer.uint32(946).fork())
                .ldelim();
        }
        if (message.get_rtc_token !== undefined) {
            exports.GetRtcTokenResponse.encode(message.get_rtc_token, writer.uint32(954).fork()).ldelim();
        }
        if (message.cancel_voice_channel !== undefined) {
            exports.CancelVoiceChannelResponse.encode(message.cancel_voice_channel, writer.uint32(962).fork()).ldelim();
        }
        if (message.reject_voice_channel !== undefined) {
            exports.RejectVoiceChannelResponse.encode(message.reject_voice_channel, writer.uint32(970).fork()).ldelim();
        }
        if (message.get_channel_list_header !== undefined) {
            exports.GetChannelListHeaderResponse.encode(message.get_channel_list_header, writer.uint32(978).fork()).ldelim();
        }
        if (message.close_channel_list_header !== undefined) {
            exports.CloseChannelListHeaderResponse.encode(message.close_channel_list_header, writer.uint32(986).fork()).ldelim();
        }
        if (message.delete_message !== undefined) {
            exports.DeleteMessageResponse.encode(message.delete_message, writer.uint32(994).fork()).ldelim();
        }
        if (message.send_persistent_menu_postback !== undefined) {
            exports.SendPersistentMenuPostbackResponse.encode(message.send_persistent_menu_postback, writer.uint32(1002).fork())
                .ldelim();
        }
        if (message.get_auto_reply_metadata !== undefined) {
            exports.GetAutoReplyMetadataResponse.encode(message.get_auto_reply_metadata, writer.uint32(1010).fork()).ldelim();
        }
        if (message.update_auto_reply_metadata !== undefined) {
            exports.UpdateAutoReplyMetadataResponse.encode(message.update_auto_reply_metadata, writer.uint32(1018).fork()).ldelim();
        }
        if (message.list_auto_replies !== undefined) {
            exports.ListAutoRepliesResponse.encode(message.list_auto_replies, writer.uint32(1026).fork()).ldelim();
        }
        if (message.create_auto_reply !== undefined) {
            exports.CreateAutoReplyResponse.encode(message.create_auto_reply, writer.uint32(1034).fork()).ldelim();
        }
        if (message.get_auto_reply !== undefined) {
            exports.GetAutoReplyResponse.encode(message.get_auto_reply, writer.uint32(1042).fork()).ldelim();
        }
        if (message.update_auto_reply !== undefined) {
            exports.UpdateAutoReplyResponse.encode(message.update_auto_reply, writer.uint32(1050).fork()).ldelim();
        }
        if (message.delete_auto_reply !== undefined) {
            exports.DeleteAutoReplyResponse.encode(message.delete_auto_reply, writer.uint32(1058).fork()).ldelim();
        }
        if (message.create_announcement !== undefined) {
            exports.CreateAnnouncementResponse.encode(message.create_announcement, writer.uint32(1066).fork()).ldelim();
        }
        if (message.delete_announcement !== undefined) {
            exports.DeleteAnnouncementResponse.encode(message.delete_announcement, writer.uint32(1074).fork()).ldelim();
        }
        if (message.set_reaction !== undefined) {
            exports.SetReactionResponse.encode(message.set_reaction, writer.uint32(1082).fork()).ldelim();
        }
        if (message.list_reaction !== undefined) {
            exports.ListReactionResponse.encode(message.list_reaction, writer.uint32(1090).fork()).ldelim();
        }
        if (message.get_filters !== undefined) {
            exports.GetFiltersResponse.encode(message.get_filters, writer.uint32(1098).fork())
                .ldelim();
        }
        if (message.get_member !== undefined) {
            exports.GetMemberResponse.encode(message.get_member, writer.uint32(1130).fork())
                .ldelim();
        }
        if (message.get_members !== undefined) {
            exports.GetMembersResponse.encode(message.get_members, writer.uint32(1138).fork())
                .ldelim();
        }
        if (message.search_members !== undefined) {
            exports.SearchMembersResponse.encode(message.search_members, writer.uint32(1146).fork()).ldelim();
        }
        if (message.send_button_postback !== undefined) {
            exports.SendButtonPostbackResponse.encode(message.send_button_postback, writer.uint32(1202).fork()).ldelim();
        }
        if (message.new_message !== undefined) {
            event_1.NewMessageEvent.encode(message.new_message, writer.uint32(1602).fork())
                .ldelim();
        }
        if (message.read_message !== undefined) {
            event_1.ReadMessageEvent.encode(message.read_message, writer.uint32(1610).fork())
                .ldelim();
        }
        if (message.join_member !== undefined) {
            event_1.JoinMemberEvent.encode(message.join_member, writer.uint32(1618).fork())
                .ldelim();
        }
        if (message.leave_member !== undefined) {
            event_1.LeaveMemberEvent.encode(message.leave_member, writer.uint32(1626).fork())
                .ldelim();
        }
        if (message.renew_channel !== undefined) {
            event_1.RenewChannelEvent.encode(message.renew_channel, writer.uint32(1634).fork()).ldelim();
        }
        if (message.update_bubble_group !== undefined) {
            event_1.UpdateBubbleGroupEvent.encode(message.update_bubble_group, writer.uint32(1642).fork()).ldelim();
        }
        if (message.update_message !== undefined) {
            event_1.UpdateMessageEvent.encode(message.update_message, writer.uint32(1650).fork()).ldelim();
        }
        if (message.join_voice_channel !== undefined) {
            event_1.JoinVoiceChannelEvent.encode(message.join_voice_channel, writer.uint32(1690).fork()).ldelim();
        }
        if (message.terminate_voice_channel !== undefined) {
            event_1.TerminateVoiceChannelEvent.encode(message.terminate_voice_channel, writer.uint32(1698).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.status = statusFromJSON(reader.int32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.echo = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.status_message = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.status_action = exports.StatusAction.decode(reader, reader.uint32());
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.send_message = exports.SendMessageResponse.decode(reader, reader.uint32());
                    continue;
                case 101:
                    if (tag !== 810) {
                        break;
                    }
                    message.get_channels = exports.GetChannelsResponse.decode(reader, reader.uint32());
                    continue;
                case 102:
                    if (tag !== 818) {
                        break;
                    }
                    message.get_messages = exports.GetMessagesResponse.decode(reader, reader.uint32());
                    continue;
                case 103:
                    if (tag !== 826) {
                        break;
                    }
                    message.create_channel = exports.CreateChannelResponse.decode(reader, reader.uint32());
                    continue;
                case 104:
                    if (tag !== 834) {
                        break;
                    }
                    message.mark_as_read = exports.MarkAsReadResponse.decode(reader, reader.uint32());
                    continue;
                case 105:
                    if (tag !== 842) {
                        break;
                    }
                    message.leave_channel = exports.LeaveChannelResponse.decode(reader, reader.uint32());
                    continue;
                case 106:
                    if (tag !== 850) {
                        break;
                    }
                    message.update_user_channel = exports.UpdateUserChannelResponse.decode(reader, reader.uint32());
                    continue;
                case 107:
                    if (tag !== 858) {
                        break;
                    }
                    message.get_channel = exports.GetChannelResponse.decode(reader, reader.uint32());
                    continue;
                case 108:
                    if (tag !== 866) {
                        break;
                    }
                    message.get_seller_channels = exports.GetSellerChannelsResponse.decode(reader, reader.uint32());
                    continue;
                case 109:
                    if (tag !== 874) {
                        break;
                    }
                    message.get_unread_count = exports.GetUnreadCountResponse.decode(reader, reader.uint32());
                    continue;
                case 110:
                    if (tag !== 882) {
                        break;
                    }
                    message.create_promise = exports.CreatePromiseResponse.decode(reader, reader.uint32());
                    continue;
                case 111:
                    if (tag !== 890) {
                        break;
                    }
                    message.update_promise = exports.UpdatePromiseResponse.decode(reader, reader.uint32());
                    continue;
                case 112:
                    if (tag !== 898) {
                        break;
                    }
                    message.delete_promise = exports.DeletePromiseResponse.decode(reader, reader.uint32());
                    continue;
                case 113:
                    if (tag !== 906) {
                        break;
                    }
                    message.get_biz_accounts = exports.GetBizAccountsResponse.decode(reader, reader.uint32());
                    continue;
                case 114:
                    if (tag !== 914) {
                        break;
                    }
                    message.get_biz_account = exports.GetBizAccountResponse.decode(reader, reader.uint32());
                    continue;
                case 115:
                    if (tag !== 922) {
                        break;
                    }
                    message.get_stickers = exports.GetStickersResponse.decode(reader, reader.uint32());
                    continue;
                case 116:
                    if (tag !== 930) {
                        break;
                    }
                    message.get_safe_number = exports.GetSafeNumberResponse.decode(reader, reader.uint32());
                    continue;
                case 117:
                    if (tag !== 938) {
                        break;
                    }
                    message.update_block_status = exports.UpdateBlockStatusResponse.decode(reader, reader.uint32());
                    continue;
                case 118:
                    if (tag !== 946) {
                        break;
                    }
                    message.ban_user = exports.BanUserResponse.decode(reader, reader.uint32());
                    continue;
                case 119:
                    if (tag !== 954) {
                        break;
                    }
                    message.get_rtc_token = exports.GetRtcTokenResponse.decode(reader, reader.uint32());
                    continue;
                case 120:
                    if (tag !== 962) {
                        break;
                    }
                    message.cancel_voice_channel = exports.CancelVoiceChannelResponse.decode(reader, reader.uint32());
                    continue;
                case 121:
                    if (tag !== 970) {
                        break;
                    }
                    message.reject_voice_channel = exports.RejectVoiceChannelResponse.decode(reader, reader.uint32());
                    continue;
                case 122:
                    if (tag !== 978) {
                        break;
                    }
                    message.get_channel_list_header = exports.GetChannelListHeaderResponse.decode(reader, reader.uint32());
                    continue;
                case 123:
                    if (tag !== 986) {
                        break;
                    }
                    message.close_channel_list_header = exports.CloseChannelListHeaderResponse
                        .decode(reader, reader.uint32());
                    continue;
                case 124:
                    if (tag !== 994) {
                        break;
                    }
                    message.delete_message = exports.DeleteMessageResponse.decode(reader, reader.uint32());
                    continue;
                case 125:
                    if (tag !== 1002) {
                        break;
                    }
                    message.send_persistent_menu_postback =
                        exports.SendPersistentMenuPostbackResponse.decode(reader, reader.uint32());
                    continue;
                case 126:
                    if (tag !== 1010) {
                        break;
                    }
                    message.get_auto_reply_metadata = exports.GetAutoReplyMetadataResponse.decode(reader, reader.uint32());
                    continue;
                case 127:
                    if (tag !== 1018) {
                        break;
                    }
                    message.update_auto_reply_metadata = exports.UpdateAutoReplyMetadataResponse
                        .decode(reader, reader.uint32());
                    continue;
                case 128:
                    if (tag !== 1026) {
                        break;
                    }
                    message.list_auto_replies = exports.ListAutoRepliesResponse.decode(reader, reader.uint32());
                    continue;
                case 129:
                    if (tag !== 1034) {
                        break;
                    }
                    message.create_auto_reply = exports.CreateAutoReplyResponse.decode(reader, reader.uint32());
                    continue;
                case 130:
                    if (tag !== 1042) {
                        break;
                    }
                    message.get_auto_reply = exports.GetAutoReplyResponse.decode(reader, reader.uint32());
                    continue;
                case 131:
                    if (tag !== 1050) {
                        break;
                    }
                    message.update_auto_reply = exports.UpdateAutoReplyResponse.decode(reader, reader.uint32());
                    continue;
                case 132:
                    if (tag !== 1058) {
                        break;
                    }
                    message.delete_auto_reply = exports.DeleteAutoReplyResponse.decode(reader, reader.uint32());
                    continue;
                case 133:
                    if (tag !== 1066) {
                        break;
                    }
                    message.create_announcement = exports.CreateAnnouncementResponse.decode(reader, reader.uint32());
                    continue;
                case 134:
                    if (tag !== 1074) {
                        break;
                    }
                    message.delete_announcement = exports.DeleteAnnouncementResponse.decode(reader, reader.uint32());
                    continue;
                case 135:
                    if (tag !== 1082) {
                        break;
                    }
                    message.set_reaction = exports.SetReactionResponse.decode(reader, reader.uint32());
                    continue;
                case 136:
                    if (tag !== 1090) {
                        break;
                    }
                    message.list_reaction = exports.ListReactionResponse.decode(reader, reader.uint32());
                    continue;
                case 137:
                    if (tag !== 1098) {
                        break;
                    }
                    message.get_filters = exports.GetFiltersResponse.decode(reader, reader.uint32());
                    continue;
                case 141:
                    if (tag !== 1130) {
                        break;
                    }
                    message.get_member = exports.GetMemberResponse.decode(reader, reader.uint32());
                    continue;
                case 142:
                    if (tag !== 1138) {
                        break;
                    }
                    message.get_members = exports.GetMembersResponse.decode(reader, reader.uint32());
                    continue;
                case 143:
                    if (tag !== 1146) {
                        break;
                    }
                    message.search_members = exports.SearchMembersResponse.decode(reader, reader.uint32());
                    continue;
                case 150:
                    if (tag !== 1202) {
                        break;
                    }
                    message.send_button_postback = exports.SendButtonPostbackResponse.decode(reader, reader.uint32());
                    continue;
                case 200:
                    if (tag !== 1602) {
                        break;
                    }
                    message.new_message = event_1.NewMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 201:
                    if (tag !== 1610) {
                        break;
                    }
                    message.read_message = event_1.ReadMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 202:
                    if (tag !== 1618) {
                        break;
                    }
                    message.join_member = event_1.JoinMemberEvent.decode(reader, reader.uint32());
                    continue;
                case 203:
                    if (tag !== 1626) {
                        break;
                    }
                    message.leave_member = event_1.LeaveMemberEvent.decode(reader, reader.uint32());
                    continue;
                case 204:
                    if (tag !== 1634) {
                        break;
                    }
                    message.renew_channel = event_1.RenewChannelEvent.decode(reader, reader.uint32());
                    continue;
                case 205:
                    if (tag !== 1642) {
                        break;
                    }
                    message.update_bubble_group = event_1.UpdateBubbleGroupEvent.decode(reader, reader.uint32());
                    continue;
                case 206:
                    if (tag !== 1650) {
                        break;
                    }
                    message.update_message = event_1.UpdateMessageEvent.decode(reader, reader.uint32());
                    continue;
                case 211:
                    if (tag !== 1690) {
                        break;
                    }
                    message.join_voice_channel = event_1.JoinVoiceChannelEvent.decode(reader, reader.uint32());
                    continue;
                case 212:
                    if (tag !== 1698) {
                        break;
                    }
                    message.terminate_voice_channel = event_1.TerminateVoiceChannelEvent.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            status: isSet(object.status)
                ? statusFromJSON(object.status)
                : Status.UNKNOWN,
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            echo: isSet(object.echo) ? globalThis.String(object.echo) : "",
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
            status_message: isSet(object.status_message)
                ? globalThis.String(object.status_message)
                : "",
            status_action: isSet(object.status_action)
                ? exports.StatusAction.fromJSON(object.status_action)
                : undefined,
            send_message: isSet(object.send_message)
                ? exports.SendMessageResponse.fromJSON(object.send_message)
                : undefined,
            get_channels: isSet(object.get_channels)
                ? exports.GetChannelsResponse.fromJSON(object.get_channels)
                : undefined,
            get_messages: isSet(object.get_messages)
                ? exports.GetMessagesResponse.fromJSON(object.get_messages)
                : undefined,
            create_channel: isSet(object.create_channel)
                ? exports.CreateChannelResponse.fromJSON(object.create_channel)
                : undefined,
            mark_as_read: isSet(object.mark_as_read)
                ? exports.MarkAsReadResponse.fromJSON(object.mark_as_read)
                : undefined,
            leave_channel: isSet(object.leave_channel)
                ? exports.LeaveChannelResponse.fromJSON(object.leave_channel)
                : undefined,
            update_user_channel: isSet(object.update_user_channel)
                ? exports.UpdateUserChannelResponse.fromJSON(object.update_user_channel)
                : undefined,
            get_channel: isSet(object.get_channel)
                ? exports.GetChannelResponse.fromJSON(object.get_channel)
                : undefined,
            get_seller_channels: isSet(object.get_seller_channels)
                ? exports.GetSellerChannelsResponse.fromJSON(object.get_seller_channels)
                : undefined,
            get_unread_count: isSet(object.get_unread_count)
                ? exports.GetUnreadCountResponse.fromJSON(object.get_unread_count)
                : undefined,
            create_promise: isSet(object.create_promise)
                ? exports.CreatePromiseResponse.fromJSON(object.create_promise)
                : undefined,
            update_promise: isSet(object.update_promise)
                ? exports.UpdatePromiseResponse.fromJSON(object.update_promise)
                : undefined,
            delete_promise: isSet(object.delete_promise)
                ? exports.DeletePromiseResponse.fromJSON(object.delete_promise)
                : undefined,
            get_biz_accounts: isSet(object.get_biz_accounts)
                ? exports.GetBizAccountsResponse.fromJSON(object.get_biz_accounts)
                : undefined,
            get_biz_account: isSet(object.get_biz_account)
                ? exports.GetBizAccountResponse.fromJSON(object.get_biz_account)
                : undefined,
            get_stickers: isSet(object.get_stickers)
                ? exports.GetStickersResponse.fromJSON(object.get_stickers)
                : undefined,
            get_safe_number: isSet(object.get_safe_number)
                ? exports.GetSafeNumberResponse.fromJSON(object.get_safe_number)
                : undefined,
            update_block_status: isSet(object.update_block_status)
                ? exports.UpdateBlockStatusResponse.fromJSON(object.update_block_status)
                : undefined,
            ban_user: isSet(object.ban_user)
                ? exports.BanUserResponse.fromJSON(object.ban_user)
                : undefined,
            get_rtc_token: isSet(object.get_rtc_token)
                ? exports.GetRtcTokenResponse.fromJSON(object.get_rtc_token)
                : undefined,
            cancel_voice_channel: isSet(object.cancel_voice_channel)
                ? exports.CancelVoiceChannelResponse.fromJSON(object.cancel_voice_channel)
                : undefined,
            reject_voice_channel: isSet(object.reject_voice_channel)
                ? exports.RejectVoiceChannelResponse.fromJSON(object.reject_voice_channel)
                : undefined,
            get_channel_list_header: isSet(object.get_channel_list_header)
                ? exports.GetChannelListHeaderResponse.fromJSON(object.get_channel_list_header)
                : undefined,
            close_channel_list_header: isSet(object.close_channel_list_header)
                ? exports.CloseChannelListHeaderResponse.fromJSON(object.close_channel_list_header)
                : undefined,
            delete_message: isSet(object.delete_message)
                ? exports.DeleteMessageResponse.fromJSON(object.delete_message)
                : undefined,
            send_persistent_menu_postback: isSet(object.send_persistent_menu_postback)
                ? exports.SendPersistentMenuPostbackResponse.fromJSON(object.send_persistent_menu_postback)
                : undefined,
            get_auto_reply_metadata: isSet(object.get_auto_reply_metadata)
                ? exports.GetAutoReplyMetadataResponse.fromJSON(object.get_auto_reply_metadata)
                : undefined,
            update_auto_reply_metadata: isSet(object.update_auto_reply_metadata)
                ? exports.UpdateAutoReplyMetadataResponse.fromJSON(object.update_auto_reply_metadata)
                : undefined,
            list_auto_replies: isSet(object.list_auto_replies)
                ? exports.ListAutoRepliesResponse.fromJSON(object.list_auto_replies)
                : undefined,
            create_auto_reply: isSet(object.create_auto_reply)
                ? exports.CreateAutoReplyResponse.fromJSON(object.create_auto_reply)
                : undefined,
            get_auto_reply: isSet(object.get_auto_reply)
                ? exports.GetAutoReplyResponse.fromJSON(object.get_auto_reply)
                : undefined,
            update_auto_reply: isSet(object.update_auto_reply)
                ? exports.UpdateAutoReplyResponse.fromJSON(object.update_auto_reply)
                : undefined,
            delete_auto_reply: isSet(object.delete_auto_reply)
                ? exports.DeleteAutoReplyResponse.fromJSON(object.delete_auto_reply)
                : undefined,
            create_announcement: isSet(object.create_announcement)
                ? exports.CreateAnnouncementResponse.fromJSON(object.create_announcement)
                : undefined,
            delete_announcement: isSet(object.delete_announcement)
                ? exports.DeleteAnnouncementResponse.fromJSON(object.delete_announcement)
                : undefined,
            set_reaction: isSet(object.set_reaction)
                ? exports.SetReactionResponse.fromJSON(object.set_reaction)
                : undefined,
            list_reaction: isSet(object.list_reaction)
                ? exports.ListReactionResponse.fromJSON(object.list_reaction)
                : undefined,
            get_filters: isSet(object.get_filters)
                ? exports.GetFiltersResponse.fromJSON(object.get_filters)
                : undefined,
            get_member: isSet(object.get_member)
                ? exports.GetMemberResponse.fromJSON(object.get_member)
                : undefined,
            get_members: isSet(object.get_members)
                ? exports.GetMembersResponse.fromJSON(object.get_members)
                : undefined,
            search_members: isSet(object.search_members)
                ? exports.SearchMembersResponse.fromJSON(object.search_members)
                : undefined,
            send_button_postback: isSet(object.send_button_postback)
                ? exports.SendButtonPostbackResponse.fromJSON(object.send_button_postback)
                : undefined,
            new_message: isSet(object.new_message)
                ? event_1.NewMessageEvent.fromJSON(object.new_message)
                : undefined,
            read_message: isSet(object.read_message)
                ? event_1.ReadMessageEvent.fromJSON(object.read_message)
                : undefined,
            join_member: isSet(object.join_member)
                ? event_1.JoinMemberEvent.fromJSON(object.join_member)
                : undefined,
            leave_member: isSet(object.leave_member)
                ? event_1.LeaveMemberEvent.fromJSON(object.leave_member)
                : undefined,
            renew_channel: isSet(object.renew_channel)
                ? event_1.RenewChannelEvent.fromJSON(object.renew_channel)
                : undefined,
            update_bubble_group: isSet(object.update_bubble_group)
                ? event_1.UpdateBubbleGroupEvent.fromJSON(object.update_bubble_group)
                : undefined,
            update_message: isSet(object.update_message)
                ? event_1.UpdateMessageEvent.fromJSON(object.update_message)
                : undefined,
            join_voice_channel: isSet(object.join_voice_channel)
                ? event_1.JoinVoiceChannelEvent.fromJSON(object.join_voice_channel)
                : undefined,
            terminate_voice_channel: isSet(object.terminate_voice_channel)
                ? event_1.TerminateVoiceChannelEvent.fromJSON(object.terminate_voice_channel)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.status !== Status.UNKNOWN) {
            obj.status = statusToJSON(message.status);
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.echo !== "") {
            obj.echo = message.echo;
        }
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        if (message.status_message !== "") {
            obj.status_message = message.status_message;
        }
        if (message.status_action !== undefined) {
            obj.status_action = exports.StatusAction.toJSON(message.status_action);
        }
        if (message.send_message !== undefined) {
            obj.send_message = exports.SendMessageResponse.toJSON(message.send_message);
        }
        if (message.get_channels !== undefined) {
            obj.get_channels = exports.GetChannelsResponse.toJSON(message.get_channels);
        }
        if (message.get_messages !== undefined) {
            obj.get_messages = exports.GetMessagesResponse.toJSON(message.get_messages);
        }
        if (message.create_channel !== undefined) {
            obj.create_channel = exports.CreateChannelResponse.toJSON(message.create_channel);
        }
        if (message.mark_as_read !== undefined) {
            obj.mark_as_read = exports.MarkAsReadResponse.toJSON(message.mark_as_read);
        }
        if (message.leave_channel !== undefined) {
            obj.leave_channel = exports.LeaveChannelResponse.toJSON(message.leave_channel);
        }
        if (message.update_user_channel !== undefined) {
            obj.update_user_channel = exports.UpdateUserChannelResponse.toJSON(message.update_user_channel);
        }
        if (message.get_channel !== undefined) {
            obj.get_channel = exports.GetChannelResponse.toJSON(message.get_channel);
        }
        if (message.get_seller_channels !== undefined) {
            obj.get_seller_channels = exports.GetSellerChannelsResponse.toJSON(message.get_seller_channels);
        }
        if (message.get_unread_count !== undefined) {
            obj.get_unread_count = exports.GetUnreadCountResponse.toJSON(message.get_unread_count);
        }
        if (message.create_promise !== undefined) {
            obj.create_promise = exports.CreatePromiseResponse.toJSON(message.create_promise);
        }
        if (message.update_promise !== undefined) {
            obj.update_promise = exports.UpdatePromiseResponse.toJSON(message.update_promise);
        }
        if (message.delete_promise !== undefined) {
            obj.delete_promise = exports.DeletePromiseResponse.toJSON(message.delete_promise);
        }
        if (message.get_biz_accounts !== undefined) {
            obj.get_biz_accounts = exports.GetBizAccountsResponse.toJSON(message.get_biz_accounts);
        }
        if (message.get_biz_account !== undefined) {
            obj.get_biz_account = exports.GetBizAccountResponse.toJSON(message.get_biz_account);
        }
        if (message.get_stickers !== undefined) {
            obj.get_stickers = exports.GetStickersResponse.toJSON(message.get_stickers);
        }
        if (message.get_safe_number !== undefined) {
            obj.get_safe_number = exports.GetSafeNumberResponse.toJSON(message.get_safe_number);
        }
        if (message.update_block_status !== undefined) {
            obj.update_block_status = exports.UpdateBlockStatusResponse.toJSON(message.update_block_status);
        }
        if (message.ban_user !== undefined) {
            obj.ban_user = exports.BanUserResponse.toJSON(message.ban_user);
        }
        if (message.get_rtc_token !== undefined) {
            obj.get_rtc_token = exports.GetRtcTokenResponse.toJSON(message.get_rtc_token);
        }
        if (message.cancel_voice_channel !== undefined) {
            obj.cancel_voice_channel = exports.CancelVoiceChannelResponse.toJSON(message.cancel_voice_channel);
        }
        if (message.reject_voice_channel !== undefined) {
            obj.reject_voice_channel = exports.RejectVoiceChannelResponse.toJSON(message.reject_voice_channel);
        }
        if (message.get_channel_list_header !== undefined) {
            obj.get_channel_list_header = exports.GetChannelListHeaderResponse.toJSON(message.get_channel_list_header);
        }
        if (message.close_channel_list_header !== undefined) {
            obj.close_channel_list_header = exports.CloseChannelListHeaderResponse.toJSON(message.close_channel_list_header);
        }
        if (message.delete_message !== undefined) {
            obj.delete_message = exports.DeleteMessageResponse.toJSON(message.delete_message);
        }
        if (message.send_persistent_menu_postback !== undefined) {
            obj.send_persistent_menu_postback = exports.SendPersistentMenuPostbackResponse
                .toJSON(message.send_persistent_menu_postback);
        }
        if (message.get_auto_reply_metadata !== undefined) {
            obj.get_auto_reply_metadata = exports.GetAutoReplyMetadataResponse.toJSON(message.get_auto_reply_metadata);
        }
        if (message.update_auto_reply_metadata !== undefined) {
            obj.update_auto_reply_metadata = exports.UpdateAutoReplyMetadataResponse.toJSON(message.update_auto_reply_metadata);
        }
        if (message.list_auto_replies !== undefined) {
            obj.list_auto_replies = exports.ListAutoRepliesResponse.toJSON(message.list_auto_replies);
        }
        if (message.create_auto_reply !== undefined) {
            obj.create_auto_reply = exports.CreateAutoReplyResponse.toJSON(message.create_auto_reply);
        }
        if (message.get_auto_reply !== undefined) {
            obj.get_auto_reply = exports.GetAutoReplyResponse.toJSON(message.get_auto_reply);
        }
        if (message.update_auto_reply !== undefined) {
            obj.update_auto_reply = exports.UpdateAutoReplyResponse.toJSON(message.update_auto_reply);
        }
        if (message.delete_auto_reply !== undefined) {
            obj.delete_auto_reply = exports.DeleteAutoReplyResponse.toJSON(message.delete_auto_reply);
        }
        if (message.create_announcement !== undefined) {
            obj.create_announcement = exports.CreateAnnouncementResponse.toJSON(message.create_announcement);
        }
        if (message.delete_announcement !== undefined) {
            obj.delete_announcement = exports.DeleteAnnouncementResponse.toJSON(message.delete_announcement);
        }
        if (message.set_reaction !== undefined) {
            obj.set_reaction = exports.SetReactionResponse.toJSON(message.set_reaction);
        }
        if (message.list_reaction !== undefined) {
            obj.list_reaction = exports.ListReactionResponse.toJSON(message.list_reaction);
        }
        if (message.get_filters !== undefined) {
            obj.get_filters = exports.GetFiltersResponse.toJSON(message.get_filters);
        }
        if (message.get_member !== undefined) {
            obj.get_member = exports.GetMemberResponse.toJSON(message.get_member);
        }
        if (message.get_members !== undefined) {
            obj.get_members = exports.GetMembersResponse.toJSON(message.get_members);
        }
        if (message.search_members !== undefined) {
            obj.search_members = exports.SearchMembersResponse.toJSON(message.search_members);
        }
        if (message.send_button_postback !== undefined) {
            obj.send_button_postback = exports.SendButtonPostbackResponse.toJSON(message.send_button_postback);
        }
        if (message.new_message !== undefined) {
            obj.new_message = event_1.NewMessageEvent.toJSON(message.new_message);
        }
        if (message.read_message !== undefined) {
            obj.read_message = event_1.ReadMessageEvent.toJSON(message.read_message);
        }
        if (message.join_member !== undefined) {
            obj.join_member = event_1.JoinMemberEvent.toJSON(message.join_member);
        }
        if (message.leave_member !== undefined) {
            obj.leave_member = event_1.LeaveMemberEvent.toJSON(message.leave_member);
        }
        if (message.renew_channel !== undefined) {
            obj.renew_channel = event_1.RenewChannelEvent.toJSON(message.renew_channel);
        }
        if (message.update_bubble_group !== undefined) {
            obj.update_bubble_group = event_1.UpdateBubbleGroupEvent.toJSON(message.update_bubble_group);
        }
        if (message.update_message !== undefined) {
            obj.update_message = event_1.UpdateMessageEvent.toJSON(message.update_message);
        }
        if (message.join_voice_channel !== undefined) {
            obj.join_voice_channel = event_1.JoinVoiceChannelEvent.toJSON(message.join_voice_channel);
        }
        if (message.terminate_voice_channel !== undefined) {
            obj.terminate_voice_channel = event_1.TerminateVoiceChannelEvent.toJSON(message.terminate_voice_channel);
        }
        return obj;
    },
    create(base) {
        return exports.Response.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseResponse();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.status = (_b = object.status) !== null && _b !== void 0 ? _b : Status.UNKNOWN;
        message.id = (_c = object.id) !== null && _c !== void 0 ? _c : "";
        message.echo = (_d = object.echo) !== null && _d !== void 0 ? _d : "";
        message.biz_account_id = (_e = object.biz_account_id) !== null && _e !== void 0 ? _e : "0";
        message.status_message = (_f = object.status_message) !== null && _f !== void 0 ? _f : "";
        message.status_action =
            (object.status_action !== undefined && object.status_action !== null)
                ? exports.StatusAction.fromPartial(object.status_action)
                : undefined;
        message.send_message =
            (object.send_message !== undefined && object.send_message !== null)
                ? exports.SendMessageResponse.fromPartial(object.send_message)
                : undefined;
        message.get_channels =
            (object.get_channels !== undefined && object.get_channels !== null)
                ? exports.GetChannelsResponse.fromPartial(object.get_channels)
                : undefined;
        message.get_messages =
            (object.get_messages !== undefined && object.get_messages !== null)
                ? exports.GetMessagesResponse.fromPartial(object.get_messages)
                : undefined;
        message.create_channel =
            (object.create_channel !== undefined && object.create_channel !== null)
                ? exports.CreateChannelResponse.fromPartial(object.create_channel)
                : undefined;
        message.mark_as_read =
            (object.mark_as_read !== undefined && object.mark_as_read !== null)
                ? exports.MarkAsReadResponse.fromPartial(object.mark_as_read)
                : undefined;
        message.leave_channel =
            (object.leave_channel !== undefined && object.leave_channel !== null)
                ? exports.LeaveChannelResponse.fromPartial(object.leave_channel)
                : undefined;
        message.update_user_channel = (object.update_user_channel !== undefined &&
            object.update_user_channel !== null)
            ? exports.UpdateUserChannelResponse.fromPartial(object.update_user_channel)
            : undefined;
        message.get_channel =
            (object.get_channel !== undefined && object.get_channel !== null)
                ? exports.GetChannelResponse.fromPartial(object.get_channel)
                : undefined;
        message.get_seller_channels = (object.get_seller_channels !== undefined &&
            object.get_seller_channels !== null)
            ? exports.GetSellerChannelsResponse.fromPartial(object.get_seller_channels)
            : undefined;
        message.get_unread_count = (object.get_unread_count !== undefined &&
            object.get_unread_count !== null)
            ? exports.GetUnreadCountResponse.fromPartial(object.get_unread_count)
            : undefined;
        message.create_promise =
            (object.create_promise !== undefined && object.create_promise !== null)
                ? exports.CreatePromiseResponse.fromPartial(object.create_promise)
                : undefined;
        message.update_promise =
            (object.update_promise !== undefined && object.update_promise !== null)
                ? exports.UpdatePromiseResponse.fromPartial(object.update_promise)
                : undefined;
        message.delete_promise =
            (object.delete_promise !== undefined && object.delete_promise !== null)
                ? exports.DeletePromiseResponse.fromPartial(object.delete_promise)
                : undefined;
        message.get_biz_accounts = (object.get_biz_accounts !== undefined &&
            object.get_biz_accounts !== null)
            ? exports.GetBizAccountsResponse.fromPartial(object.get_biz_accounts)
            : undefined;
        message.get_biz_account =
            (object.get_biz_account !== undefined && object.get_biz_account !== null)
                ? exports.GetBizAccountResponse.fromPartial(object.get_biz_account)
                : undefined;
        message.get_stickers =
            (object.get_stickers !== undefined && object.get_stickers !== null)
                ? exports.GetStickersResponse.fromPartial(object.get_stickers)
                : undefined;
        message.get_safe_number =
            (object.get_safe_number !== undefined && object.get_safe_number !== null)
                ? exports.GetSafeNumberResponse.fromPartial(object.get_safe_number)
                : undefined;
        message.update_block_status = (object.update_block_status !== undefined &&
            object.update_block_status !== null)
            ? exports.UpdateBlockStatusResponse.fromPartial(object.update_block_status)
            : undefined;
        message.ban_user =
            (object.ban_user !== undefined && object.ban_user !== null)
                ? exports.BanUserResponse.fromPartial(object.ban_user)
                : undefined;
        message.get_rtc_token =
            (object.get_rtc_token !== undefined && object.get_rtc_token !== null)
                ? exports.GetRtcTokenResponse.fromPartial(object.get_rtc_token)
                : undefined;
        message.cancel_voice_channel = (object.cancel_voice_channel !== undefined &&
            object.cancel_voice_channel !== null)
            ? exports.CancelVoiceChannelResponse.fromPartial(object.cancel_voice_channel)
            : undefined;
        message.reject_voice_channel = (object.reject_voice_channel !== undefined &&
            object.reject_voice_channel !== null)
            ? exports.RejectVoiceChannelResponse.fromPartial(object.reject_voice_channel)
            : undefined;
        message.get_channel_list_header =
            (object.get_channel_list_header !== undefined &&
                object.get_channel_list_header !== null)
                ? exports.GetChannelListHeaderResponse.fromPartial(object.get_channel_list_header)
                : undefined;
        message.close_channel_list_header =
            (object.close_channel_list_header !== undefined &&
                object.close_channel_list_header !== null)
                ? exports.CloseChannelListHeaderResponse.fromPartial(object.close_channel_list_header)
                : undefined;
        message.delete_message =
            (object.delete_message !== undefined && object.delete_message !== null)
                ? exports.DeleteMessageResponse.fromPartial(object.delete_message)
                : undefined;
        message.send_persistent_menu_postback =
            (object.send_persistent_menu_postback !== undefined &&
                object.send_persistent_menu_postback !== null)
                ? exports.SendPersistentMenuPostbackResponse.fromPartial(object.send_persistent_menu_postback)
                : undefined;
        message.get_auto_reply_metadata =
            (object.get_auto_reply_metadata !== undefined &&
                object.get_auto_reply_metadata !== null)
                ? exports.GetAutoReplyMetadataResponse.fromPartial(object.get_auto_reply_metadata)
                : undefined;
        message.update_auto_reply_metadata =
            (object.update_auto_reply_metadata !== undefined &&
                object.update_auto_reply_metadata !== null)
                ? exports.UpdateAutoReplyMetadataResponse.fromPartial(object.update_auto_reply_metadata)
                : undefined;
        message.list_auto_replies = (object.list_auto_replies !== undefined &&
            object.list_auto_replies !== null)
            ? exports.ListAutoRepliesResponse.fromPartial(object.list_auto_replies)
            : undefined;
        message.create_auto_reply = (object.create_auto_reply !== undefined &&
            object.create_auto_reply !== null)
            ? exports.CreateAutoReplyResponse.fromPartial(object.create_auto_reply)
            : undefined;
        message.get_auto_reply =
            (object.get_auto_reply !== undefined && object.get_auto_reply !== null)
                ? exports.GetAutoReplyResponse.fromPartial(object.get_auto_reply)
                : undefined;
        message.update_auto_reply = (object.update_auto_reply !== undefined &&
            object.update_auto_reply !== null)
            ? exports.UpdateAutoReplyResponse.fromPartial(object.update_auto_reply)
            : undefined;
        message.delete_auto_reply = (object.delete_auto_reply !== undefined &&
            object.delete_auto_reply !== null)
            ? exports.DeleteAutoReplyResponse.fromPartial(object.delete_auto_reply)
            : undefined;
        message.create_announcement = (object.create_announcement !== undefined &&
            object.create_announcement !== null)
            ? exports.CreateAnnouncementResponse.fromPartial(object.create_announcement)
            : undefined;
        message.delete_announcement = (object.delete_announcement !== undefined &&
            object.delete_announcement !== null)
            ? exports.DeleteAnnouncementResponse.fromPartial(object.delete_announcement)
            : undefined;
        message.set_reaction =
            (object.set_reaction !== undefined && object.set_reaction !== null)
                ? exports.SetReactionResponse.fromPartial(object.set_reaction)
                : undefined;
        message.list_reaction =
            (object.list_reaction !== undefined && object.list_reaction !== null)
                ? exports.ListReactionResponse.fromPartial(object.list_reaction)
                : undefined;
        message.get_filters =
            (object.get_filters !== undefined && object.get_filters !== null)
                ? exports.GetFiltersResponse.fromPartial(object.get_filters)
                : undefined;
        message.get_member =
            (object.get_member !== undefined && object.get_member !== null)
                ? exports.GetMemberResponse.fromPartial(object.get_member)
                : undefined;
        message.get_members =
            (object.get_members !== undefined && object.get_members !== null)
                ? exports.GetMembersResponse.fromPartial(object.get_members)
                : undefined;
        message.search_members =
            (object.search_members !== undefined && object.search_members !== null)
                ? exports.SearchMembersResponse.fromPartial(object.search_members)
                : undefined;
        message.send_button_postback = (object.send_button_postback !== undefined &&
            object.send_button_postback !== null)
            ? exports.SendButtonPostbackResponse.fromPartial(object.send_button_postback)
            : undefined;
        message.new_message =
            (object.new_message !== undefined && object.new_message !== null)
                ? event_1.NewMessageEvent.fromPartial(object.new_message)
                : undefined;
        message.read_message =
            (object.read_message !== undefined && object.read_message !== null)
                ? event_1.ReadMessageEvent.fromPartial(object.read_message)
                : undefined;
        message.join_member =
            (object.join_member !== undefined && object.join_member !== null)
                ? event_1.JoinMemberEvent.fromPartial(object.join_member)
                : undefined;
        message.leave_member =
            (object.leave_member !== undefined && object.leave_member !== null)
                ? event_1.LeaveMemberEvent.fromPartial(object.leave_member)
                : undefined;
        message.renew_channel =
            (object.renew_channel !== undefined && object.renew_channel !== null)
                ? event_1.RenewChannelEvent.fromPartial(object.renew_channel)
                : undefined;
        message.update_bubble_group = (object.update_bubble_group !== undefined &&
            object.update_bubble_group !== null)
            ? event_1.UpdateBubbleGroupEvent.fromPartial(object.update_bubble_group)
            : undefined;
        message.update_message =
            (object.update_message !== undefined && object.update_message !== null)
                ? event_1.UpdateMessageEvent.fromPartial(object.update_message)
                : undefined;
        message.join_voice_channel = (object.join_voice_channel !== undefined &&
            object.join_voice_channel !== null)
            ? event_1.JoinVoiceChannelEvent.fromPartial(object.join_voice_channel)
            : undefined;
        message.terminate_voice_channel =
            (object.terminate_voice_channel !== undefined &&
                object.terminate_voice_channel !== null)
                ? event_1.TerminateVoiceChannelEvent.fromPartial(object.terminate_voice_channel)
                : undefined;
        return message;
    },
};
function createBaseCreateChannelRequest() {
    return {
        sender_id: "0",
        receiver_id: "0",
        resource_type: "",
        resource_id: "0",
        message: undefined,
        data: "",
        read_only: false,
        sender: undefined,
        receiver: undefined,
        tags: {},
    };
}
exports.CreateChannelRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sender_id !== "0") {
            writer.uint32(8).int64(message.sender_id);
        }
        if (message.receiver_id !== "0") {
            writer.uint32(16).int64(message.receiver_id);
        }
        if (message.resource_type !== "") {
            writer.uint32(26).string(message.resource_type);
        }
        if (message.resource_id !== "0") {
            writer.uint32(32).int64(message.resource_id);
        }
        if (message.message !== undefined) {
            model_1.Message.encode(message.message, writer.uint32(42).fork()).ldelim();
        }
        if (message.data !== "") {
            writer.uint32(50).string(message.data);
        }
        if (message.read_only !== false) {
            writer.uint32(56).bool(message.read_only);
        }
        if (message.sender !== undefined) {
            model_1.User.encode(message.sender, writer.uint32(66).fork()).ldelim();
        }
        if (message.receiver !== undefined) {
            model_1.User.encode(message.receiver, writer.uint32(74).fork()).ldelim();
        }
        Object.entries(message.tags).forEach(([key, value]) => {
            exports.CreateChannelRequest_TagsEntry.encode({ key: key, value }, writer.uint32(82).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.sender_id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.receiver_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.resource_type = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.resource_id = longToString(reader.int64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.message = model_1.Message.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.data = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.read_only = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.sender = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.receiver = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    const entry10 = exports.CreateChannelRequest_TagsEntry.decode(reader, reader.uint32());
                    if (entry10.value !== undefined) {
                        message.tags[entry10.key] = entry10.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender_id: isSet(object.sender_id)
                ? globalThis.String(object.sender_id)
                : "0",
            receiver_id: isSet(object.receiver_id)
                ? globalThis.String(object.receiver_id)
                : "0",
            resource_type: isSet(object.resource_type)
                ? globalThis.String(object.resource_type)
                : "",
            resource_id: isSet(object.resource_id)
                ? globalThis.String(object.resource_id)
                : "0",
            message: isSet(object.message)
                ? model_1.Message.fromJSON(object.message)
                : undefined,
            data: isSet(object.data) ? globalThis.String(object.data) : "",
            read_only: isSet(object.read_only)
                ? globalThis.Boolean(object.read_only)
                : false,
            sender: isSet(object.sender) ? model_1.User.fromJSON(object.sender) : undefined,
            receiver: isSet(object.receiver)
                ? model_1.User.fromJSON(object.receiver)
                : undefined,
            tags: isObject(object.tags)
                ? Object.entries(object.tags).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sender_id !== "0") {
            obj.sender_id = message.sender_id;
        }
        if (message.receiver_id !== "0") {
            obj.receiver_id = message.receiver_id;
        }
        if (message.resource_type !== "") {
            obj.resource_type = message.resource_type;
        }
        if (message.resource_id !== "0") {
            obj.resource_id = message.resource_id;
        }
        if (message.message !== undefined) {
            obj.message = model_1.Message.toJSON(message.message);
        }
        if (message.data !== "") {
            obj.data = message.data;
        }
        if (message.read_only !== false) {
            obj.read_only = message.read_only;
        }
        if (message.sender !== undefined) {
            obj.sender = model_1.User.toJSON(message.sender);
        }
        if (message.receiver !== undefined) {
            obj.receiver = model_1.User.toJSON(message.receiver);
        }
        if (message.tags) {
            const entries = Object.entries(message.tags);
            if (entries.length > 0) {
                obj.tags = {};
                entries.forEach(([k, v]) => {
                    obj.tags[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.CreateChannelRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = createBaseCreateChannelRequest();
        message.sender_id = (_a = object.sender_id) !== null && _a !== void 0 ? _a : "0";
        message.receiver_id = (_b = object.receiver_id) !== null && _b !== void 0 ? _b : "0";
        message.resource_type = (_c = object.resource_type) !== null && _c !== void 0 ? _c : "";
        message.resource_id = (_d = object.resource_id) !== null && _d !== void 0 ? _d : "0";
        message.message = (object.message !== undefined && object.message !== null)
            ? model_1.Message.fromPartial(object.message)
            : undefined;
        message.data = (_e = object.data) !== null && _e !== void 0 ? _e : "";
        message.read_only = (_f = object.read_only) !== null && _f !== void 0 ? _f : false;
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? model_1.User.fromPartial(object.sender)
            : undefined;
        message.receiver =
            (object.receiver !== undefined && object.receiver !== null)
                ? model_1.User.fromPartial(object.receiver)
                : undefined;
        message.tags = Object.entries((_g = object.tags) !== null && _g !== void 0 ? _g : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseCreateChannelRequest_TagsEntry() {
    return { key: "", value: "" };
}
exports.CreateChannelRequest_TagsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateChannelRequest_TagsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.CreateChannelRequest_TagsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCreateChannelRequest_TagsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseCreateChannelResponse() {
    return { channel: undefined, message: undefined, more_menu: undefined };
}
exports.CreateChannelResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel !== undefined) {
            model_1.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        }
        if (message.message !== undefined) {
            model_1.Message.encode(message.message, writer.uint32(18).fork()).ldelim();
        }
        if (message.more_menu !== undefined) {
            model_1.MoreMenu.encode(message.more_menu, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel = model_1.Channel.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = model_1.Message.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.more_menu = model_1.MoreMenu.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel: isSet(object.channel)
                ? model_1.Channel.fromJSON(object.channel)
                : undefined,
            message: isSet(object.message)
                ? model_1.Message.fromJSON(object.message)
                : undefined,
            more_menu: isSet(object.more_menu)
                ? model_1.MoreMenu.fromJSON(object.more_menu)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel !== undefined) {
            obj.channel = model_1.Channel.toJSON(message.channel);
        }
        if (message.message !== undefined) {
            obj.message = model_1.Message.toJSON(message.message);
        }
        if (message.more_menu !== undefined) {
            obj.more_menu = model_1.MoreMenu.toJSON(message.more_menu);
        }
        return obj;
    },
    create(base) {
        return exports.CreateChannelResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseCreateChannelResponse();
        message.channel = (object.channel !== undefined && object.channel !== null)
            ? model_1.Channel.fromPartial(object.channel)
            : undefined;
        message.message = (object.message !== undefined && object.message !== null)
            ? model_1.Message.fromPartial(object.message)
            : undefined;
        message.more_menu =
            (object.more_menu !== undefined && object.more_menu !== null)
                ? model_1.MoreMenu.fromPartial(object.more_menu)
                : undefined;
        return message;
    },
};
function createBaseSendMessageRequest() {
    return { message: undefined, read_only_channel: false, tags: {} };
}
exports.SendMessageRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== undefined) {
            model_1.Message.encode(message.message, writer.uint32(10).fork()).ldelim();
        }
        if (message.read_only_channel !== false) {
            writer.uint32(16).bool(message.read_only_channel);
        }
        Object.entries(message.tags).forEach(([key, value]) => {
            exports.SendMessageRequest_TagsEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendMessageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = model_1.Message.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.read_only_channel = reader.bool();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    const entry3 = exports.SendMessageRequest_TagsEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.tags[entry3.key] = entry3.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message)
                ? model_1.Message.fromJSON(object.message)
                : undefined,
            read_only_channel: isSet(object.read_only_channel)
                ? globalThis.Boolean(object.read_only_channel)
                : false,
            tags: isObject(object.tags)
                ? Object.entries(object.tags).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined) {
            obj.message = model_1.Message.toJSON(message.message);
        }
        if (message.read_only_channel !== false) {
            obj.read_only_channel = message.read_only_channel;
        }
        if (message.tags) {
            const entries = Object.entries(message.tags);
            if (entries.length > 0) {
                obj.tags = {};
                entries.forEach(([k, v]) => {
                    obj.tags[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.SendMessageRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSendMessageRequest();
        message.message = (object.message !== undefined && object.message !== null)
            ? model_1.Message.fromPartial(object.message)
            : undefined;
        message.read_only_channel = (_a = object.read_only_channel) !== null && _a !== void 0 ? _a : false;
        message.tags = Object.entries((_b = object.tags) !== null && _b !== void 0 ? _b : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseSendMessageRequest_TagsEntry() {
    return { key: "", value: "" };
}
exports.SendMessageRequest_TagsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendMessageRequest_TagsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return exports.SendMessageRequest_TagsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSendMessageRequest_TagsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseSendMessageResponse() {
    return { message: undefined };
}
exports.SendMessageResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== undefined) {
            model_1.Message.encode(message.message, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendMessageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = model_1.Message.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message)
                ? model_1.Message.fromJSON(object.message)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined) {
            obj.message = model_1.Message.toJSON(message.message);
        }
        return obj;
    },
    create(base) {
        return exports.SendMessageResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseSendMessageResponse();
        message.message = (object.message !== undefined && object.message !== null)
            ? model_1.Message.fromPartial(object.message)
            : undefined;
        return message;
    },
};
function createBaseAckEventRequest() {
    return { protocol_name: "", id: "" };
}
exports.AckEventRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.protocol_name !== "") {
            writer.uint32(10).string(message.protocol_name);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAckEventRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.protocol_name = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            protocol_name: isSet(object.protocol_name)
                ? globalThis.String(object.protocol_name)
                : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.protocol_name !== "") {
            obj.protocol_name = message.protocol_name;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.AckEventRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseAckEventRequest();
        message.protocol_name = (_a = object.protocol_name) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseGetChannelsRequest() {
    return {
        with_last_message: false,
        base_time: undefined,
        limit: 0,
        range: Range.GREATER,
        paging_key: undefined,
        filter_id: undefined,
    };
}
exports.GetChannelsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.with_last_message !== false) {
            writer.uint32(8).bool(message.with_last_message);
        }
        if (message.base_time !== undefined) {
            timestamp_1.Timestamp.encode(message.base_time, writer.uint32(18).fork()).ldelim();
        }
        if (message.limit !== 0) {
            writer.uint32(24).int32(message.limit);
        }
        if (message.range !== Range.GREATER) {
            writer.uint32(32).int32(rangeToNumber(message.range));
        }
        if (message.paging_key !== undefined) {
            exports.GetChannelsRequest_PagingKey.encode(message.paging_key, writer.uint32(42).fork()).ldelim();
        }
        if (message.filter_id !== undefined) {
            writer.uint32(48).int32((0, model_1.filterIDToNumber)(message.filter_id));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChannelsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.with_last_message = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.base_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.limit = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.range = rangeFromJSON(reader.int32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.paging_key = exports.GetChannelsRequest_PagingKey.decode(reader, reader.uint32());
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.filter_id = (0, model_1.filterIDFromJSON)(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            with_last_message: isSet(object.with_last_message)
                ? globalThis.Boolean(object.with_last_message)
                : false,
            base_time: isSet(object.base_time)
                ? fromJsonTimestamp(object.base_time)
                : undefined,
            limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
            range: isSet(object.range) ? rangeFromJSON(object.range) : Range.GREATER,
            paging_key: isSet(object.paging_key)
                ? exports.GetChannelsRequest_PagingKey.fromJSON(object.paging_key)
                : undefined,
            filter_id: isSet(object.filter_id)
                ? (0, model_1.filterIDFromJSON)(object.filter_id)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.with_last_message !== false) {
            obj.with_last_message = message.with_last_message;
        }
        if (message.base_time !== undefined) {
            obj.base_time = fromTimestamp(message.base_time).toISOString();
        }
        if (message.limit !== 0) {
            obj.limit = Math.round(message.limit);
        }
        if (message.range !== Range.GREATER) {
            obj.range = rangeToJSON(message.range);
        }
        if (message.paging_key !== undefined) {
            obj.paging_key = exports.GetChannelsRequest_PagingKey.toJSON(message.paging_key);
        }
        if (message.filter_id !== undefined) {
            obj.filter_id = (0, model_1.filterIDToJSON)(message.filter_id);
        }
        return obj;
    },
    create(base) {
        return exports.GetChannelsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseGetChannelsRequest();
        message.with_last_message = (_a = object.with_last_message) !== null && _a !== void 0 ? _a : false;
        message.base_time =
            (object.base_time !== undefined && object.base_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.base_time)
                : undefined;
        message.limit = (_b = object.limit) !== null && _b !== void 0 ? _b : 0;
        message.range = (_c = object.range) !== null && _c !== void 0 ? _c : Range.GREATER;
        message.paging_key =
            (object.paging_key !== undefined && object.paging_key !== null)
                ? exports.GetChannelsRequest_PagingKey.fromPartial(object.paging_key)
                : undefined;
        message.filter_id = (_d = object.filter_id) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseGetChannelsRequest_PagingKey() {
    return {
        kind: GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED,
        time: undefined,
    };
}
exports.GetChannelsRequest_PagingKey = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.kind !== GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED) {
            writer.uint32(8).int32(getChannelsRequest_PagingKey_KindToNumber(message.kind));
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChannelsRequest_PagingKey();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.kind = getChannelsRequest_PagingKey_KindFromJSON(reader.int32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            kind: isSet(object.kind)
                ? getChannelsRequest_PagingKey_KindFromJSON(object.kind)
                : GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED,
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.kind !== GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED) {
            obj.kind = getChannelsRequest_PagingKey_KindToJSON(message.kind);
        }
        if (message.time !== undefined) {
            obj.time = fromTimestamp(message.time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.GetChannelsRequest_PagingKey.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetChannelsRequest_PagingKey();
        message.kind = (_a = object.kind) !== null && _a !== void 0 ? _a : GetChannelsRequest_PagingKey_Kind.KIND_UNSPECIFIED;
        message.time = (object.time !== undefined && object.time !== null)
            ? timestamp_1.Timestamp.fromPartial(object.time)
            : undefined;
        return message;
    },
};
function createBaseGetChannelsResponse() {
    return {
        channels: [],
        unread_count: undefined,
        next_base_time: undefined,
        next_paging_key: undefined,
        filter_id: undefined,
    };
}
exports.GetChannelsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.channels) {
            model_1.Channel.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.unread_count !== undefined) {
            model_1.UnreadCount.encode(message.unread_count, writer.uint32(18).fork())
                .ldelim();
        }
        if (message.next_base_time !== undefined) {
            timestamp_1.Timestamp.encode(message.next_base_time, writer.uint32(26).fork())
                .ldelim();
        }
        if (message.next_paging_key !== undefined) {
            exports.GetChannelsRequest_PagingKey.encode(message.next_paging_key, writer.uint32(34).fork()).ldelim();
        }
        if (message.filter_id !== undefined) {
            writer.uint32(40).int32((0, model_1.filterIDToNumber)(message.filter_id));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChannelsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channels.push(model_1.Channel.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.unread_count = model_1.UnreadCount.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.next_base_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.next_paging_key = exports.GetChannelsRequest_PagingKey.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.filter_id = (0, model_1.filterIDFromJSON)(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channels: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.channels)
                ? object.channels.map((e) => model_1.Channel.fromJSON(e))
                : [],
            unread_count: isSet(object.unread_count)
                ? model_1.UnreadCount.fromJSON(object.unread_count)
                : undefined,
            next_base_time: isSet(object.next_base_time)
                ? fromJsonTimestamp(object.next_base_time)
                : undefined,
            next_paging_key: isSet(object.next_paging_key)
                ? exports.GetChannelsRequest_PagingKey.fromJSON(object.next_paging_key)
                : undefined,
            filter_id: isSet(object.filter_id)
                ? (0, model_1.filterIDFromJSON)(object.filter_id)
                : undefined,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.channels) === null || _a === void 0 ? void 0 : _a.length) {
            obj.channels = message.channels.map((e) => model_1.Channel.toJSON(e));
        }
        if (message.unread_count !== undefined) {
            obj.unread_count = model_1.UnreadCount.toJSON(message.unread_count);
        }
        if (message.next_base_time !== undefined) {
            obj.next_base_time = fromTimestamp(message.next_base_time).toISOString();
        }
        if (message.next_paging_key !== undefined) {
            obj.next_paging_key = exports.GetChannelsRequest_PagingKey.toJSON(message.next_paging_key);
        }
        if (message.filter_id !== undefined) {
            obj.filter_id = (0, model_1.filterIDToJSON)(message.filter_id);
        }
        return obj;
    },
    create(base) {
        return exports.GetChannelsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetChannelsResponse();
        message.channels = ((_a = object.channels) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.Channel.fromPartial(e))) ||
            [];
        message.unread_count =
            (object.unread_count !== undefined && object.unread_count !== null)
                ? model_1.UnreadCount.fromPartial(object.unread_count)
                : undefined;
        message.next_base_time =
            (object.next_base_time !== undefined && object.next_base_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.next_base_time)
                : undefined;
        message.next_paging_key =
            (object.next_paging_key !== undefined && object.next_paging_key !== null)
                ? exports.GetChannelsRequest_PagingKey.fromPartial(object.next_paging_key)
                : undefined;
        message.filter_id = (_b = object.filter_id) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseGetSellerChannelsRequest() {
    return {
        with_last_message: false,
        resource_type: "",
        resource_id: "0",
        smb_id: "0",
        smb_article_id: "0",
    };
}
exports.GetSellerChannelsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.with_last_message !== false) {
            writer.uint32(8).bool(message.with_last_message);
        }
        if (message.resource_type !== "") {
            writer.uint32(18).string(message.resource_type);
        }
        if (message.resource_id !== "0") {
            writer.uint32(24).int64(message.resource_id);
        }
        if (message.smb_id !== "0") {
            writer.uint32(32).int64(message.smb_id);
        }
        if (message.smb_article_id !== "0") {
            writer.uint32(40).int64(message.smb_article_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSellerChannelsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.with_last_message = reader.bool();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.resource_type = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.resource_id = longToString(reader.int64());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.smb_id = longToString(reader.int64());
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.smb_article_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            with_last_message: isSet(object.with_last_message)
                ? globalThis.Boolean(object.with_last_message)
                : false,
            resource_type: isSet(object.resource_type)
                ? globalThis.String(object.resource_type)
                : "",
            resource_id: isSet(object.resource_id)
                ? globalThis.String(object.resource_id)
                : "0",
            smb_id: isSet(object.smb_id) ? globalThis.String(object.smb_id) : "0",
            smb_article_id: isSet(object.smb_article_id)
                ? globalThis.String(object.smb_article_id)
                : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.with_last_message !== false) {
            obj.with_last_message = message.with_last_message;
        }
        if (message.resource_type !== "") {
            obj.resource_type = message.resource_type;
        }
        if (message.resource_id !== "0") {
            obj.resource_id = message.resource_id;
        }
        if (message.smb_id !== "0") {
            obj.smb_id = message.smb_id;
        }
        if (message.smb_article_id !== "0") {
            obj.smb_article_id = message.smb_article_id;
        }
        return obj;
    },
    create(base) {
        return exports.GetSellerChannelsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseGetSellerChannelsRequest();
        message.with_last_message = (_a = object.with_last_message) !== null && _a !== void 0 ? _a : false;
        message.resource_type = (_b = object.resource_type) !== null && _b !== void 0 ? _b : "";
        message.resource_id = (_c = object.resource_id) !== null && _c !== void 0 ? _c : "0";
        message.smb_id = (_d = object.smb_id) !== null && _d !== void 0 ? _d : "0";
        message.smb_article_id = (_e = object.smb_article_id) !== null && _e !== void 0 ? _e : "0";
        return message;
    },
};
function createBaseGetSellerChannelsResponse() {
    return { channels: [] };
}
exports.GetSellerChannelsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.channels) {
            model_1.Channel.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSellerChannelsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channels.push(model_1.Channel.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channels: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.channels)
                ? object.channels.map((e) => model_1.Channel.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.channels) === null || _a === void 0 ? void 0 : _a.length) {
            obj.channels = message.channels.map((e) => model_1.Channel.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetSellerChannelsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetSellerChannelsResponse();
        message.channels = ((_a = object.channels) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.Channel.fromPartial(e))) ||
            [];
        return message;
    },
};
function createBaseGetMessagesRequest() {
    return { channel_id: "", message_id: "0", limit: 0, range: Range.GREATER };
}
exports.GetMessagesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.limit !== 0) {
            writer.uint32(24).int32(message.limit);
        }
        if (message.range !== Range.GREATER) {
            writer.uint32(32).int32(rangeToNumber(message.range));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetMessagesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.limit = reader.int32();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.range = rangeFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            limit: isSet(object.limit) ? globalThis.Number(object.limit) : 0,
            range: isSet(object.range) ? rangeFromJSON(object.range) : Range.GREATER,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.limit !== 0) {
            obj.limit = Math.round(message.limit);
        }
        if (message.range !== Range.GREATER) {
            obj.range = rangeToJSON(message.range);
        }
        return obj;
    },
    create(base) {
        return exports.GetMessagesRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseGetMessagesRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.limit = (_c = object.limit) !== null && _c !== void 0 ? _c : 0;
        message.range = (_d = object.range) !== null && _d !== void 0 ? _d : Range.GREATER;
        return message;
    },
};
function createBaseGetMessagesResponse() {
    return { messages: [] };
}
exports.GetMessagesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.messages) {
            model_1.Message.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetMessagesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.messages.push(model_1.Message.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            messages: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.messages)
                ? object.messages.map((e) => model_1.Message.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.messages) === null || _a === void 0 ? void 0 : _a.length) {
            obj.messages = message.messages.map((e) => model_1.Message.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetMessagesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetMessagesResponse();
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.Message.fromPartial(e))) ||
            [];
        return message;
    },
};
function createBaseMarkAsReadRequest() {
    return { channel_id: "", message_id: "0" };
}
exports.MarkAsReadRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMarkAsReadRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        return obj;
    },
    create(base) {
        return exports.MarkAsReadRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMarkAsReadRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        return message;
    },
};
function createBaseMarkAsReadResponse() {
    return { channel_id: "", unread_count: undefined };
}
exports.MarkAsReadResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.unread_count !== undefined) {
            model_1.UnreadCount.encode(message.unread_count, writer.uint32(18).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMarkAsReadResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.unread_count = model_1.UnreadCount.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            unread_count: isSet(object.unread_count)
                ? model_1.UnreadCount.fromJSON(object.unread_count)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.unread_count !== undefined) {
            obj.unread_count = model_1.UnreadCount.toJSON(message.unread_count);
        }
        return obj;
    },
    create(base) {
        return exports.MarkAsReadResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMarkAsReadResponse();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.unread_count =
            (object.unread_count !== undefined && object.unread_count !== null)
                ? model_1.UnreadCount.fromPartial(object.unread_count)
                : undefined;
        return message;
    },
};
function createBaseLeaveChannelRequest() {
    return { channel_id: "" };
}
exports.LeaveChannelRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLeaveChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        return obj;
    },
    create(base) {
        return exports.LeaveChannelRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseLeaveChannelRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseLeaveChannelResponse() {
    return {};
}
exports.LeaveChannelResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLeaveChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.LeaveChannelResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseLeaveChannelResponse();
        return message;
    },
};
function createBaseUpdateUserChannelRequest() {
    return {
        channel_id: "",
        is_favorite: false,
        is_disabled: false,
        is_mute: false,
        with_last_message: false,
        favorite: undefined,
        disabled: undefined,
        mute: undefined,
    };
}
exports.UpdateUserChannelRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.is_favorite !== false) {
            writer.uint32(16).bool(message.is_favorite);
        }
        if (message.is_disabled !== false) {
            writer.uint32(24).bool(message.is_disabled);
        }
        if (message.is_mute !== false) {
            writer.uint32(32).bool(message.is_mute);
        }
        if (message.with_last_message !== false) {
            writer.uint32(40).bool(message.with_last_message);
        }
        if (message.favorite !== undefined) {
            writer.uint32(88).bool(message.favorite);
        }
        if (message.disabled !== undefined) {
            writer.uint32(96).bool(message.disabled);
        }
        if (message.mute !== undefined) {
            writer.uint32(104).bool(message.mute);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateUserChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.is_favorite = reader.bool();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.is_disabled = reader.bool();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.is_mute = reader.bool();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.with_last_message = reader.bool();
                    continue;
                case 11:
                    if (tag !== 88) {
                        break;
                    }
                    message.favorite = reader.bool();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.disabled = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.mute = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            is_favorite: isSet(object.is_favorite)
                ? globalThis.Boolean(object.is_favorite)
                : false,
            is_disabled: isSet(object.is_disabled)
                ? globalThis.Boolean(object.is_disabled)
                : false,
            is_mute: isSet(object.is_mute)
                ? globalThis.Boolean(object.is_mute)
                : false,
            with_last_message: isSet(object.with_last_message)
                ? globalThis.Boolean(object.with_last_message)
                : false,
            favorite: isSet(object.favorite)
                ? globalThis.Boolean(object.favorite)
                : undefined,
            disabled: isSet(object.disabled)
                ? globalThis.Boolean(object.disabled)
                : undefined,
            mute: isSet(object.mute) ? globalThis.Boolean(object.mute) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.is_favorite !== false) {
            obj.is_favorite = message.is_favorite;
        }
        if (message.is_disabled !== false) {
            obj.is_disabled = message.is_disabled;
        }
        if (message.is_mute !== false) {
            obj.is_mute = message.is_mute;
        }
        if (message.with_last_message !== false) {
            obj.with_last_message = message.with_last_message;
        }
        if (message.favorite !== undefined) {
            obj.favorite = message.favorite;
        }
        if (message.disabled !== undefined) {
            obj.disabled = message.disabled;
        }
        if (message.mute !== undefined) {
            obj.mute = message.mute;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateUserChannelRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = createBaseUpdateUserChannelRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.is_favorite = (_b = object.is_favorite) !== null && _b !== void 0 ? _b : false;
        message.is_disabled = (_c = object.is_disabled) !== null && _c !== void 0 ? _c : false;
        message.is_mute = (_d = object.is_mute) !== null && _d !== void 0 ? _d : false;
        message.with_last_message = (_e = object.with_last_message) !== null && _e !== void 0 ? _e : false;
        message.favorite = (_f = object.favorite) !== null && _f !== void 0 ? _f : undefined;
        message.disabled = (_g = object.disabled) !== null && _g !== void 0 ? _g : undefined;
        message.mute = (_h = object.mute) !== null && _h !== void 0 ? _h : undefined;
        return message;
    },
};
function createBaseUpdateUserChannelResponse() {
    return { channel: undefined, favorite_time: undefined };
}
exports.UpdateUserChannelResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel !== undefined) {
            model_1.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        }
        if (message.favorite_time !== undefined) {
            timestamp_1.Timestamp.encode(message.favorite_time, writer.uint32(18).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateUserChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel = model_1.Channel.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.favorite_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel: isSet(object.channel)
                ? model_1.Channel.fromJSON(object.channel)
                : undefined,
            favorite_time: isSet(object.favorite_time)
                ? fromJsonTimestamp(object.favorite_time)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel !== undefined) {
            obj.channel = model_1.Channel.toJSON(message.channel);
        }
        if (message.favorite_time !== undefined) {
            obj.favorite_time = fromTimestamp(message.favorite_time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.UpdateUserChannelResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUpdateUserChannelResponse();
        message.channel = (object.channel !== undefined && object.channel !== null)
            ? model_1.Channel.fromPartial(object.channel)
            : undefined;
        message.favorite_time =
            (object.favorite_time !== undefined && object.favorite_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.favorite_time)
                : undefined;
        return message;
    },
};
function createBaseGetChannelRequest() {
    return {
        sender_id: "0",
        receiver_id: "0",
        resource_type: "",
        resource_id: "0",
        channel_id: "",
        with_last_message: false,
        force: false,
        sender: undefined,
        receiver: undefined,
        with_announcement: false,
        chat_room_key: "",
    };
}
exports.GetChannelRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sender_id !== "0") {
            writer.uint32(8).int64(message.sender_id);
        }
        if (message.receiver_id !== "0") {
            writer.uint32(16).int64(message.receiver_id);
        }
        if (message.resource_type !== "") {
            writer.uint32(26).string(message.resource_type);
        }
        if (message.resource_id !== "0") {
            writer.uint32(32).int64(message.resource_id);
        }
        if (message.channel_id !== "") {
            writer.uint32(42).string(message.channel_id);
        }
        if (message.with_last_message !== false) {
            writer.uint32(48).bool(message.with_last_message);
        }
        if (message.force !== false) {
            writer.uint32(56).bool(message.force);
        }
        if (message.sender !== undefined) {
            model_1.User.encode(message.sender, writer.uint32(66).fork()).ldelim();
        }
        if (message.receiver !== undefined) {
            model_1.User.encode(message.receiver, writer.uint32(74).fork()).ldelim();
        }
        if (message.with_announcement !== false) {
            writer.uint32(80).bool(message.with_announcement);
        }
        if (message.chat_room_key !== "") {
            writer.uint32(410).string(message.chat_room_key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.sender_id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.receiver_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.resource_type = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.resource_id = longToString(reader.int64());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.with_last_message = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.force = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.sender = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    message.receiver = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 10:
                    if (tag !== 80) {
                        break;
                    }
                    message.with_announcement = reader.bool();
                    continue;
                case 51:
                    if (tag !== 410) {
                        break;
                    }
                    message.chat_room_key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sender_id: isSet(object.sender_id)
                ? globalThis.String(object.sender_id)
                : "0",
            receiver_id: isSet(object.receiver_id)
                ? globalThis.String(object.receiver_id)
                : "0",
            resource_type: isSet(object.resource_type)
                ? globalThis.String(object.resource_type)
                : "",
            resource_id: isSet(object.resource_id)
                ? globalThis.String(object.resource_id)
                : "0",
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            with_last_message: isSet(object.with_last_message)
                ? globalThis.Boolean(object.with_last_message)
                : false,
            force: isSet(object.force) ? globalThis.Boolean(object.force) : false,
            sender: isSet(object.sender) ? model_1.User.fromJSON(object.sender) : undefined,
            receiver: isSet(object.receiver)
                ? model_1.User.fromJSON(object.receiver)
                : undefined,
            with_announcement: isSet(object.with_announcement)
                ? globalThis.Boolean(object.with_announcement)
                : false,
            chat_room_key: isSet(object.chat_room_key)
                ? globalThis.String(object.chat_room_key)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sender_id !== "0") {
            obj.sender_id = message.sender_id;
        }
        if (message.receiver_id !== "0") {
            obj.receiver_id = message.receiver_id;
        }
        if (message.resource_type !== "") {
            obj.resource_type = message.resource_type;
        }
        if (message.resource_id !== "0") {
            obj.resource_id = message.resource_id;
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.with_last_message !== false) {
            obj.with_last_message = message.with_last_message;
        }
        if (message.force !== false) {
            obj.force = message.force;
        }
        if (message.sender !== undefined) {
            obj.sender = model_1.User.toJSON(message.sender);
        }
        if (message.receiver !== undefined) {
            obj.receiver = model_1.User.toJSON(message.receiver);
        }
        if (message.with_announcement !== false) {
            obj.with_announcement = message.with_announcement;
        }
        if (message.chat_room_key !== "") {
            obj.chat_room_key = message.chat_room_key;
        }
        return obj;
    },
    create(base) {
        return exports.GetChannelRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = createBaseGetChannelRequest();
        message.sender_id = (_a = object.sender_id) !== null && _a !== void 0 ? _a : "0";
        message.receiver_id = (_b = object.receiver_id) !== null && _b !== void 0 ? _b : "0";
        message.resource_type = (_c = object.resource_type) !== null && _c !== void 0 ? _c : "";
        message.resource_id = (_d = object.resource_id) !== null && _d !== void 0 ? _d : "0";
        message.channel_id = (_e = object.channel_id) !== null && _e !== void 0 ? _e : "";
        message.with_last_message = (_f = object.with_last_message) !== null && _f !== void 0 ? _f : false;
        message.force = (_g = object.force) !== null && _g !== void 0 ? _g : false;
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? model_1.User.fromPartial(object.sender)
            : undefined;
        message.receiver =
            (object.receiver !== undefined && object.receiver !== null)
                ? model_1.User.fromPartial(object.receiver)
                : undefined;
        message.with_announcement = (_h = object.with_announcement) !== null && _h !== void 0 ? _h : false;
        message.chat_room_key = (_j = object.chat_room_key) !== null && _j !== void 0 ? _j : "";
        return message;
    },
};
function createBaseGetChannelResponse() {
    return {
        channel: undefined,
        persistent_menu: undefined,
        announcement: undefined,
        more_menu: undefined,
        top_bar: undefined,
    };
}
exports.GetChannelResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel !== undefined) {
            model_1.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        }
        if (message.persistent_menu !== undefined) {
            model_1.PersistentMenu.encode(message.persistent_menu, writer.uint32(18).fork())
                .ldelim();
        }
        if (message.announcement !== undefined) {
            model_1.Announcement.encode(message.announcement, writer.uint32(26).fork())
                .ldelim();
        }
        if (message.more_menu !== undefined) {
            model_1.MoreMenu.encode(message.more_menu, writer.uint32(34).fork()).ldelim();
        }
        if (message.top_bar !== undefined) {
            model_1.TopBar.encode(message.top_bar, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel = model_1.Channel.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.persistent_menu = model_1.PersistentMenu.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.announcement = model_1.Announcement.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.more_menu = model_1.MoreMenu.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.top_bar = model_1.TopBar.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel: isSet(object.channel)
                ? model_1.Channel.fromJSON(object.channel)
                : undefined,
            persistent_menu: isSet(object.persistent_menu)
                ? model_1.PersistentMenu.fromJSON(object.persistent_menu)
                : undefined,
            announcement: isSet(object.announcement)
                ? model_1.Announcement.fromJSON(object.announcement)
                : undefined,
            more_menu: isSet(object.more_menu)
                ? model_1.MoreMenu.fromJSON(object.more_menu)
                : undefined,
            top_bar: isSet(object.top_bar)
                ? model_1.TopBar.fromJSON(object.top_bar)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel !== undefined) {
            obj.channel = model_1.Channel.toJSON(message.channel);
        }
        if (message.persistent_menu !== undefined) {
            obj.persistent_menu = model_1.PersistentMenu.toJSON(message.persistent_menu);
        }
        if (message.announcement !== undefined) {
            obj.announcement = model_1.Announcement.toJSON(message.announcement);
        }
        if (message.more_menu !== undefined) {
            obj.more_menu = model_1.MoreMenu.toJSON(message.more_menu);
        }
        if (message.top_bar !== undefined) {
            obj.top_bar = model_1.TopBar.toJSON(message.top_bar);
        }
        return obj;
    },
    create(base) {
        return exports.GetChannelResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetChannelResponse();
        message.channel = (object.channel !== undefined && object.channel !== null)
            ? model_1.Channel.fromPartial(object.channel)
            : undefined;
        message.persistent_menu =
            (object.persistent_menu !== undefined && object.persistent_menu !== null)
                ? model_1.PersistentMenu.fromPartial(object.persistent_menu)
                : undefined;
        message.announcement =
            (object.announcement !== undefined && object.announcement !== null)
                ? model_1.Announcement.fromPartial(object.announcement)
                : undefined;
        message.more_menu =
            (object.more_menu !== undefined && object.more_menu !== null)
                ? model_1.MoreMenu.fromPartial(object.more_menu)
                : undefined;
        message.top_bar = (object.top_bar !== undefined && object.top_bar !== null)
            ? model_1.TopBar.fromPartial(object.top_bar)
            : undefined;
        return message;
    },
};
function createBaseGetUnreadCountRequest() {
    return {};
}
exports.GetUnreadCountRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetUnreadCountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUnreadCountRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseGetUnreadCountRequest();
        return message;
    },
};
function createBaseGetUnreadCountResponse() {
    return { unread_count: undefined };
}
exports.GetUnreadCountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.unread_count !== undefined) {
            model_1.UnreadCount.encode(message.unread_count, writer.uint32(10).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetUnreadCountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.unread_count = model_1.UnreadCount.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            unread_count: isSet(object.unread_count)
                ? model_1.UnreadCount.fromJSON(object.unread_count)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unread_count !== undefined) {
            obj.unread_count = model_1.UnreadCount.toJSON(message.unread_count);
        }
        return obj;
    },
    create(base) {
        return exports.GetUnreadCountResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetUnreadCountResponse();
        message.unread_count =
            (object.unread_count !== undefined && object.unread_count !== null)
                ? model_1.UnreadCount.fromPartial(object.unread_count)
                : undefined;
        return message;
    },
};
function createBaseCreatePromiseRequest() {
    return { channel_id: "", time: undefined, notify_before_minutes: 0 };
}
exports.CreatePromiseRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        }
        if (message.notify_before_minutes !== 0) {
            writer.uint32(24).int32(message.notify_before_minutes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreatePromiseRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.notify_before_minutes = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            notify_before_minutes: isSet(object.notify_before_minutes)
                ? globalThis.Number(object.notify_before_minutes)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.time !== undefined) {
            obj.time = fromTimestamp(message.time).toISOString();
        }
        if (message.notify_before_minutes !== 0) {
            obj.notify_before_minutes = Math.round(message.notify_before_minutes);
        }
        return obj;
    },
    create(base) {
        return exports.CreatePromiseRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCreatePromiseRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.time = (object.time !== undefined && object.time !== null)
            ? timestamp_1.Timestamp.fromPartial(object.time)
            : undefined;
        message.notify_before_minutes = (_b = object.notify_before_minutes) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseCreatePromiseResponse() {
    return { promise: undefined };
}
exports.CreatePromiseResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promise !== undefined) {
            model_1.Promise.encode(message.promise, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreatePromiseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.promise = model_1.Promise.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            promise: isSet(object.promise)
                ? model_1.Promise.fromJSON(object.promise)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.promise !== undefined) {
            obj.promise = model_1.Promise.toJSON(message.promise);
        }
        return obj;
    },
    create(base) {
        return exports.CreatePromiseResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseCreatePromiseResponse();
        message.promise = (object.promise !== undefined && object.promise !== null)
            ? model_1.Promise.fromPartial(object.promise)
            : undefined;
        return message;
    },
};
function createBaseUpdatePromiseRequest() {
    return { id: "0", channel_id: "", time: undefined, notify_before_minutes: 0 };
}
exports.UpdatePromiseRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.channel_id !== "") {
            writer.uint32(18).string(message.channel_id);
        }
        if (message.time !== undefined) {
            timestamp_1.Timestamp.encode(message.time, writer.uint32(26).fork()).ldelim();
        }
        if (message.notify_before_minutes !== 0) {
            writer.uint32(32).int32(message.notify_before_minutes);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdatePromiseRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 32) {
                        break;
                    }
                    message.notify_before_minutes = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            time: isSet(object.time) ? fromJsonTimestamp(object.time) : undefined,
            notify_before_minutes: isSet(object.notify_before_minutes)
                ? globalThis.Number(object.notify_before_minutes)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.time !== undefined) {
            obj.time = fromTimestamp(message.time).toISOString();
        }
        if (message.notify_before_minutes !== 0) {
            obj.notify_before_minutes = Math.round(message.notify_before_minutes);
        }
        return obj;
    },
    create(base) {
        return exports.UpdatePromiseRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseUpdatePromiseRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.channel_id = (_b = object.channel_id) !== null && _b !== void 0 ? _b : "";
        message.time = (object.time !== undefined && object.time !== null)
            ? timestamp_1.Timestamp.fromPartial(object.time)
            : undefined;
        message.notify_before_minutes = (_c = object.notify_before_minutes) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseUpdatePromiseResponse() {
    return { promise: undefined };
}
exports.UpdatePromiseResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.promise !== undefined) {
            model_1.Promise.encode(message.promise, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdatePromiseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.promise = model_1.Promise.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            promise: isSet(object.promise)
                ? model_1.Promise.fromJSON(object.promise)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.promise !== undefined) {
            obj.promise = model_1.Promise.toJSON(message.promise);
        }
        return obj;
    },
    create(base) {
        return exports.UpdatePromiseResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUpdatePromiseResponse();
        message.promise = (object.promise !== undefined && object.promise !== null)
            ? model_1.Promise.fromPartial(object.promise)
            : undefined;
        return message;
    },
};
function createBaseDeletePromiseRequest() {
    return { id: "0", channel_id: "" };
}
exports.DeletePromiseRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "0") {
            writer.uint32(8).int64(message.id);
        }
        if (message.channel_id !== "") {
            writer.uint32(18).string(message.channel_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeletePromiseRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "0",
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "0") {
            obj.id = message.id;
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        return obj;
    },
    create(base) {
        return exports.DeletePromiseRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDeletePromiseRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.channel_id = (_b = object.channel_id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseDeletePromiseResponse() {
    return {};
}
exports.DeletePromiseResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeletePromiseResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeletePromiseResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseDeletePromiseResponse();
        return message;
    },
};
function createBaseGetBizAccountsRequest() {
    return {};
}
exports.GetBizAccountsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBizAccountsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetBizAccountsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseGetBizAccountsRequest();
        return message;
    },
};
function createBaseGetBizAccountsResponse() {
    return { biz_accounts: [] };
}
exports.GetBizAccountsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.biz_accounts) {
            model_1.BizAccount.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBizAccountsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.biz_accounts.push(model_1.BizAccount.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            biz_accounts: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.biz_accounts)
                ? object.biz_accounts.map((e) => model_1.BizAccount.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.biz_accounts) === null || _a === void 0 ? void 0 : _a.length) {
            obj.biz_accounts = message.biz_accounts.map((e) => model_1.BizAccount.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetBizAccountsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetBizAccountsResponse();
        message.biz_accounts =
            ((_a = object.biz_accounts) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.BizAccount.fromPartial(e))) || [];
        return message;
    },
};
function createBaseGetBizAccountRequest() {
    return { biz_account_id: "0" };
}
exports.GetBizAccountRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.biz_account_id !== "0") {
            writer.uint32(8).int64(message.biz_account_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBizAccountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.biz_account_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            biz_account_id: isSet(object.biz_account_id)
                ? globalThis.String(object.biz_account_id)
                : "0",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.biz_account_id !== "0") {
            obj.biz_account_id = message.biz_account_id;
        }
        return obj;
    },
    create(base) {
        return exports.GetBizAccountRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetBizAccountRequest();
        message.biz_account_id = (_a = object.biz_account_id) !== null && _a !== void 0 ? _a : "0";
        return message;
    },
};
function createBaseGetBizAccountResponse() {
    return { biz_account: undefined };
}
exports.GetBizAccountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.biz_account !== undefined) {
            model_1.BizAccount.encode(message.biz_account, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetBizAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.biz_account = model_1.BizAccount.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            biz_account: isSet(object.biz_account)
                ? model_1.BizAccount.fromJSON(object.biz_account)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.biz_account !== undefined) {
            obj.biz_account = model_1.BizAccount.toJSON(message.biz_account);
        }
        return obj;
    },
    create(base) {
        return exports.GetBizAccountResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetBizAccountResponse();
        message.biz_account =
            (object.biz_account !== undefined && object.biz_account !== null)
                ? model_1.BizAccount.fromPartial(object.biz_account)
                : undefined;
        return message;
    },
};
function createBaseGetStickersRequest() {
    return {};
}
exports.GetStickersRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStickersRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetStickersRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseGetStickersRequest();
        return message;
    },
};
function createBaseGetStickersResponse() {
    return { stickers: [] };
}
exports.GetStickersResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.stickers) {
            exports.GetStickersResponse_Sticker.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStickersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.stickers.push(exports.GetStickersResponse_Sticker.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            stickers: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.stickers)
                ? object.stickers.map((e) => exports.GetStickersResponse_Sticker.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.stickers) === null || _a === void 0 ? void 0 : _a.length) {
            obj.stickers = message.stickers.map((e) => exports.GetStickersResponse_Sticker.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetStickersResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetStickersResponse();
        message.stickers =
            ((_a = object.stickers) === null || _a === void 0 ? void 0 : _a.map((e) => exports.GetStickersResponse_Sticker.fromPartial(e))) ||
                [];
        return message;
    },
};
function createBaseGetStickersResponse_Sticker() {
    return { id: 0, name: "", picture_id: "", file: "", width: 0, height: 0 };
}
exports.GetStickersResponse_Sticker = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.picture_id !== "") {
            writer.uint32(34).string(message.picture_id);
        }
        if (message.file !== "") {
            writer.uint32(42).string(message.file);
        }
        if (message.width !== 0) {
            writer.uint32(48).int32(message.width);
        }
        if (message.height !== 0) {
            writer.uint32(56).int32(message.height);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetStickersResponse_Sticker();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.picture_id = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.file = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.width = reader.int32();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.height = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            picture_id: isSet(object.picture_id)
                ? globalThis.String(object.picture_id)
                : "",
            file: isSet(object.file) ? globalThis.String(object.file) : "",
            width: isSet(object.width) ? globalThis.Number(object.width) : 0,
            height: isSet(object.height) ? globalThis.Number(object.height) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.picture_id !== "") {
            obj.picture_id = message.picture_id;
        }
        if (message.file !== "") {
            obj.file = message.file;
        }
        if (message.width !== 0) {
            obj.width = Math.round(message.width);
        }
        if (message.height !== 0) {
            obj.height = Math.round(message.height);
        }
        return obj;
    },
    create(base) {
        return exports.GetStickersResponse_Sticker.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = createBaseGetStickersResponse_Sticker();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.picture_id = (_c = object.picture_id) !== null && _c !== void 0 ? _c : "";
        message.file = (_d = object.file) !== null && _d !== void 0 ? _d : "";
        message.width = (_e = object.width) !== null && _e !== void 0 ? _e : 0;
        message.height = (_f = object.height) !== null && _f !== void 0 ? _f : 0;
        return message;
    },
};
function createBaseGetSafeNumberRequest() {
    return { channel_id: "", receiver: undefined };
}
exports.GetSafeNumberRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.receiver !== undefined) {
            model_1.User.encode(message.receiver, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSafeNumberRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.receiver = model_1.User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            receiver: isSet(object.receiver)
                ? model_1.User.fromJSON(object.receiver)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.receiver !== undefined) {
            obj.receiver = model_1.User.toJSON(message.receiver);
        }
        return obj;
    },
    create(base) {
        return exports.GetSafeNumberRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetSafeNumberRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.receiver =
            (object.receiver !== undefined && object.receiver !== null)
                ? model_1.User.fromPartial(object.receiver)
                : undefined;
        return message;
    },
};
function createBaseGetSafeNumberResponse() {
    return { receiver_safe_number: "", release_time: undefined };
}
exports.GetSafeNumberResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.receiver_safe_number !== "") {
            writer.uint32(10).string(message.receiver_safe_number);
        }
        if (message.release_time !== undefined) {
            timestamp_1.Timestamp.encode(message.release_time, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetSafeNumberResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.receiver_safe_number = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.release_time = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            receiver_safe_number: isSet(object.receiver_safe_number)
                ? globalThis.String(object.receiver_safe_number)
                : "",
            release_time: isSet(object.release_time)
                ? fromJsonTimestamp(object.release_time)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.receiver_safe_number !== "") {
            obj.receiver_safe_number = message.receiver_safe_number;
        }
        if (message.release_time !== undefined) {
            obj.release_time = fromTimestamp(message.release_time).toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.GetSafeNumberResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetSafeNumberResponse();
        message.receiver_safe_number = (_a = object.receiver_safe_number) !== null && _a !== void 0 ? _a : "";
        message.release_time =
            (object.release_time !== undefined && object.release_time !== null)
                ? timestamp_1.Timestamp.fromPartial(object.release_time)
                : undefined;
        return message;
    },
};
function createBaseUpdateBlockStatusRequest() {
    return { user: undefined, target_user: undefined, block_status: false };
}
exports.UpdateBlockStatusRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.user !== undefined) {
            model_1.User.encode(message.user, writer.uint32(10).fork()).ldelim();
        }
        if (message.target_user !== undefined) {
            model_1.User.encode(message.target_user, writer.uint32(18).fork()).ldelim();
        }
        if (message.block_status !== false) {
            writer.uint32(24).bool(message.block_status);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateBlockStatusRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.user = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.target_user = model_1.User.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.block_status = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            user: isSet(object.user) ? model_1.User.fromJSON(object.user) : undefined,
            target_user: isSet(object.target_user)
                ? model_1.User.fromJSON(object.target_user)
                : undefined,
            block_status: isSet(object.block_status)
                ? globalThis.Boolean(object.block_status)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = model_1.User.toJSON(message.user);
        }
        if (message.target_user !== undefined) {
            obj.target_user = model_1.User.toJSON(message.target_user);
        }
        if (message.block_status !== false) {
            obj.block_status = message.block_status;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateBlockStatusRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUpdateBlockStatusRequest();
        message.user = (object.user !== undefined && object.user !== null)
            ? model_1.User.fromPartial(object.user)
            : undefined;
        message.target_user =
            (object.target_user !== undefined && object.target_user !== null)
                ? model_1.User.fromPartial(object.target_user)
                : undefined;
        message.block_status = (_a = object.block_status) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseUpdateBlockStatusResponse() {
    return {};
}
exports.UpdateBlockStatusResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateBlockStatusResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdateBlockStatusResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseUpdateBlockStatusResponse();
        return message;
    },
};
function createBaseBanUserRequest() {
    return { channel_id: "", user: undefined };
}
exports.BanUserRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.user !== undefined) {
            model_1.User.encode(message.user, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBanUserRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.user = model_1.User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            user: isSet(object.user) ? model_1.User.fromJSON(object.user) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.user !== undefined) {
            obj.user = model_1.User.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.BanUserRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseBanUserRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.user = (object.user !== undefined && object.user !== null)
            ? model_1.User.fromPartial(object.user)
            : undefined;
        return message;
    },
};
function createBaseBanUserResponse() {
    return {};
}
exports.BanUserResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBanUserResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.BanUserResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseBanUserResponse();
        return message;
    },
};
function createBaseGetRtcTokenRequest() {
    return { channel_id: "", invite: false };
}
exports.GetRtcTokenRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.invite !== false) {
            writer.uint32(16).bool(message.invite);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRtcTokenRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.invite = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            invite: isSet(object.invite) ? globalThis.Boolean(object.invite) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.invite !== false) {
            obj.invite = message.invite;
        }
        return obj;
    },
    create(base) {
        return exports.GetRtcTokenRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetRtcTokenRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.invite = (_b = object.invite) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseGetRtcTokenResponse() {
    return { token: "", channel_id: "", uids: {} };
}
exports.GetRtcTokenResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.token !== "") {
            writer.uint32(10).string(message.token);
        }
        if (message.channel_id !== "") {
            writer.uint32(18).string(message.channel_id);
        }
        Object.entries(message.uids).forEach(([key, value]) => {
            exports.GetRtcTokenResponse_UidsEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRtcTokenResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.token = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    const entry3 = exports.GetRtcTokenResponse_UidsEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.uids[entry3.key] = entry3.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            token: isSet(object.token) ? globalThis.String(object.token) : "",
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            uids: isObject(object.uids)
                ? Object.entries(object.uids).reduce((acc, [key, value]) => {
                    acc[key] = Number(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.token !== "") {
            obj.token = message.token;
        }
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.uids) {
            const entries = Object.entries(message.uids);
            if (entries.length > 0) {
                obj.uids = {};
                entries.forEach(([k, v]) => {
                    obj.uids[k] = Math.round(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.GetRtcTokenResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseGetRtcTokenResponse();
        message.token = (_a = object.token) !== null && _a !== void 0 ? _a : "";
        message.channel_id = (_b = object.channel_id) !== null && _b !== void 0 ? _b : "";
        message.uids = Object.entries((_c = object.uids) !== null && _c !== void 0 ? _c : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.Number(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseGetRtcTokenResponse_UidsEntry() {
    return { key: "0", value: 0 };
}
exports.GetRtcTokenResponse_UidsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "0") {
            writer.uint32(8).int64(message.key);
        }
        if (message.value !== 0) {
            writer.uint32(16).uint32(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetRtcTokenResponse_UidsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.key = longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.value = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "0",
            value: isSet(object.value) ? globalThis.Number(object.value) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "0") {
            obj.key = message.key;
        }
        if (message.value !== 0) {
            obj.value = Math.round(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.GetRtcTokenResponse_UidsEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetRtcTokenResponse_UidsEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "0";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseCancelVoiceChannelRequest() {
    return {
        channel_id: "",
        reason: event_1.TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
    };
}
exports.CancelVoiceChannelRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.reason !==
            event_1.TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            writer.uint32(16).int32((0, event_1.terminateVoiceChannelReasonToNumber)(message.reason));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelVoiceChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.reason = (0, event_1.terminateVoiceChannelReasonFromJSON)(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            reason: isSet(object.reason)
                ? (0, event_1.terminateVoiceChannelReasonFromJSON)(object.reason)
                : event_1.TerminateVoiceChannelReason
                    .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.reason !==
            event_1.TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            obj.reason = (0, event_1.terminateVoiceChannelReasonToJSON)(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.CancelVoiceChannelRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseCancelVoiceChannelRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.reason = (_b = object.reason) !== null && _b !== void 0 ? _b : event_1.TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseCancelVoiceChannelResponse() {
    return { channel_id: "" };
}
exports.CancelVoiceChannelResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCancelVoiceChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        return obj;
    },
    create(base) {
        return exports.CancelVoiceChannelResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCancelVoiceChannelResponse();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseRejectVoiceChannelRequest() {
    return {
        channel_id: "",
        reason: event_1.TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
    };
}
exports.RejectVoiceChannelRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.reason !==
            event_1.TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            writer.uint32(16).int32((0, event_1.terminateVoiceChannelReasonToNumber)(message.reason));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRejectVoiceChannelRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.reason = (0, event_1.terminateVoiceChannelReasonFromJSON)(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            reason: isSet(object.reason)
                ? (0, event_1.terminateVoiceChannelReasonFromJSON)(object.reason)
                : event_1.TerminateVoiceChannelReason
                    .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.reason !==
            event_1.TerminateVoiceChannelReason
                .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED) {
            obj.reason = (0, event_1.terminateVoiceChannelReasonToJSON)(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.RejectVoiceChannelRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseRejectVoiceChannelRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.reason = (_b = object.reason) !== null && _b !== void 0 ? _b : event_1.TerminateVoiceChannelReason
            .TERMINATE_VOICE_CHANNEL_REASON_TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseRejectVoiceChannelResponse() {
    return { channel_id: "" };
}
exports.RejectVoiceChannelResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRejectVoiceChannelResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        return obj;
    },
    create(base) {
        return exports.RejectVoiceChannelResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseRejectVoiceChannelResponse();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseGetChannelListHeaderRequest() {
    return {};
}
exports.GetChannelListHeaderRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChannelListHeaderRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetChannelListHeaderRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseGetChannelListHeaderRequest();
        return message;
    },
};
function createBaseGetChannelListHeaderResponse() {
    return { channel_list_header: undefined };
}
exports.GetChannelListHeaderResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_list_header !== undefined) {
            model_1.ChannelListHeader.encode(message.channel_list_header, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetChannelListHeaderResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_list_header = model_1.ChannelListHeader.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_list_header: isSet(object.channel_list_header)
                ? model_1.ChannelListHeader.fromJSON(object.channel_list_header)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_list_header !== undefined) {
            obj.channel_list_header = model_1.ChannelListHeader.toJSON(message.channel_list_header);
        }
        return obj;
    },
    create(base) {
        return exports.GetChannelListHeaderResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetChannelListHeaderResponse();
        message.channel_list_header = (object.channel_list_header !== undefined &&
            object.channel_list_header !== null)
            ? model_1.ChannelListHeader.fromPartial(object.channel_list_header)
            : undefined;
        return message;
    },
};
function createBaseCloseChannelListHeaderRequest() {
    return { id: "" };
}
exports.CloseChannelListHeaderRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCloseChannelListHeaderRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.CloseChannelListHeaderRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseCloseChannelListHeaderRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseCloseChannelListHeaderResponse() {
    return {};
}
exports.CloseChannelListHeaderResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCloseChannelListHeaderResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CloseChannelListHeaderResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseCloseChannelListHeaderResponse();
        return message;
    },
};
function createBaseDeleteMessageRequest() {
    return {
        channel_id: "",
        message_id: "0",
        delete_by_role: DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED,
    };
}
exports.DeleteMessageRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.message_id !== "0") {
            writer.uint32(16).int64(message.message_id);
        }
        if (message.delete_by_role !==
            DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED) {
            writer.uint32(24).int32(deleteMessageRequest_DeleteByRoleToNumber(message.delete_by_role));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteMessageRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.delete_by_role = deleteMessageRequest_DeleteByRoleFromJSON(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : "0",
            delete_by_role: isSet(object.delete_by_role)
                ? deleteMessageRequest_DeleteByRoleFromJSON(object.delete_by_role)
                : DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.message_id !== "0") {
            obj.message_id = message.message_id;
        }
        if (message.delete_by_role !==
            DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED) {
            obj.delete_by_role = deleteMessageRequest_DeleteByRoleToJSON(message.delete_by_role);
        }
        return obj;
    },
    create(base) {
        return exports.DeleteMessageRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseDeleteMessageRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.message_id = (_b = object.message_id) !== null && _b !== void 0 ? _b : "0";
        message.delete_by_role = (_c = object.delete_by_role) !== null && _c !== void 0 ? _c : DeleteMessageRequest_DeleteByRole.DELETE_BY_UNSPECIFIED;
        return message;
    },
};
function createBaseDeleteMessageResponse() {
    return { message: undefined };
}
exports.DeleteMessageResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.message !== undefined) {
            model_1.Message.encode(message.message, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteMessageResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = model_1.Message.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message)
                ? model_1.Message.fromJSON(object.message)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== undefined) {
            obj.message = model_1.Message.toJSON(message.message);
        }
        return obj;
    },
    create(base) {
        return exports.DeleteMessageResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseDeleteMessageResponse();
        message.message = (object.message !== undefined && object.message !== null)
            ? model_1.Message.fromPartial(object.message)
            : undefined;
        return message;
    },
};
function createBaseSendPersistentMenuPostbackRequest() {
    return { channel_id: "", payload: "" };
}
exports.SendPersistentMenuPostbackRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.payload !== "") {
            writer.uint32(18).string(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendPersistentMenuPostbackRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            payload: isSet(object.payload) ? globalThis.String(object.payload) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.payload !== "") {
            obj.payload = message.payload;
        }
        return obj;
    },
    create(base) {
        return exports.SendPersistentMenuPostbackRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSendPersistentMenuPostbackRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseSendPersistentMenuPostbackResponse() {
    return {};
}
exports.SendPersistentMenuPostbackResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendPersistentMenuPostbackResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SendPersistentMenuPostbackResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseSendPersistentMenuPostbackResponse();
        return message;
    },
};
function createBaseGetAutoReplyMetadataRequest() {
    return {};
}
exports.GetAutoReplyMetadataRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetAutoReplyMetadataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetAutoReplyMetadataRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseGetAutoReplyMetadataRequest();
        return message;
    },
};
function createBaseGetAutoReplyMetadataResponse() {
    return { auto_reply_metadata: undefined };
}
exports.GetAutoReplyMetadataResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.auto_reply_metadata !== undefined) {
            model_1.AutoReplyMetadata.encode(message.auto_reply_metadata, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetAutoReplyMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.auto_reply_metadata = model_1.AutoReplyMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            auto_reply_metadata: isSet(object.auto_reply_metadata)
                ? model_1.AutoReplyMetadata.fromJSON(object.auto_reply_metadata)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.auto_reply_metadata !== undefined) {
            obj.auto_reply_metadata = model_1.AutoReplyMetadata.toJSON(message.auto_reply_metadata);
        }
        return obj;
    },
    create(base) {
        return exports.GetAutoReplyMetadataResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetAutoReplyMetadataResponse();
        message.auto_reply_metadata = (object.auto_reply_metadata !== undefined &&
            object.auto_reply_metadata !== null)
            ? model_1.AutoReplyMetadata.fromPartial(object.auto_reply_metadata)
            : undefined;
        return message;
    },
};
function createBaseUpdateAutoReplyMetadataRequest() {
    return { active: false };
}
exports.UpdateAutoReplyMetadataRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.active !== false) {
            writer.uint32(8).bool(message.active);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateAutoReplyMetadataRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.active = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.active !== false) {
            obj.active = message.active;
        }
        return obj;
    },
    create(base) {
        return exports.UpdateAutoReplyMetadataRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUpdateAutoReplyMetadataRequest();
        message.active = (_a = object.active) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseUpdateAutoReplyMetadataResponse() {
    return { auto_reply_metadata: undefined };
}
exports.UpdateAutoReplyMetadataResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.auto_reply_metadata !== undefined) {
            model_1.AutoReplyMetadata.encode(message.auto_reply_metadata, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateAutoReplyMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.auto_reply_metadata = model_1.AutoReplyMetadata.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            auto_reply_metadata: isSet(object.auto_reply_metadata)
                ? model_1.AutoReplyMetadata.fromJSON(object.auto_reply_metadata)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.auto_reply_metadata !== undefined) {
            obj.auto_reply_metadata = model_1.AutoReplyMetadata.toJSON(message.auto_reply_metadata);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateAutoReplyMetadataResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUpdateAutoReplyMetadataResponse();
        message.auto_reply_metadata = (object.auto_reply_metadata !== undefined &&
            object.auto_reply_metadata !== null)
            ? model_1.AutoReplyMetadata.fromPartial(object.auto_reply_metadata)
            : undefined;
        return message;
    },
};
function createBaseCreateAutoReplyRequest() {
    return { question: undefined, answer: undefined };
}
exports.CreateAutoReplyRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.question !== undefined) {
            model_1.AutoReplyQuestion.encode(message.question, writer.uint32(10).fork())
                .ldelim();
        }
        if (message.answer !== undefined) {
            model_1.AutoReplyAnswer.encode(message.answer, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateAutoReplyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.question = model_1.AutoReplyQuestion.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.answer = model_1.AutoReplyAnswer.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            question: isSet(object.question)
                ? model_1.AutoReplyQuestion.fromJSON(object.question)
                : undefined,
            answer: isSet(object.answer)
                ? model_1.AutoReplyAnswer.fromJSON(object.answer)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.question !== undefined) {
            obj.question = model_1.AutoReplyQuestion.toJSON(message.question);
        }
        if (message.answer !== undefined) {
            obj.answer = model_1.AutoReplyAnswer.toJSON(message.answer);
        }
        return obj;
    },
    create(base) {
        return exports.CreateAutoReplyRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseCreateAutoReplyRequest();
        message.question =
            (object.question !== undefined && object.question !== null)
                ? model_1.AutoReplyQuestion.fromPartial(object.question)
                : undefined;
        message.answer = (object.answer !== undefined && object.answer !== null)
            ? model_1.AutoReplyAnswer.fromPartial(object.answer)
            : undefined;
        return message;
    },
};
function createBaseCreateAutoReplyResponse() {
    return { auto_reply: undefined };
}
exports.CreateAutoReplyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.auto_reply !== undefined) {
            model_1.AutoReply.encode(message.auto_reply, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateAutoReplyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.auto_reply = model_1.AutoReply.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            auto_reply: isSet(object.auto_reply)
                ? model_1.AutoReply.fromJSON(object.auto_reply)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.auto_reply !== undefined) {
            obj.auto_reply = model_1.AutoReply.toJSON(message.auto_reply);
        }
        return obj;
    },
    create(base) {
        return exports.CreateAutoReplyResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseCreateAutoReplyResponse();
        message.auto_reply =
            (object.auto_reply !== undefined && object.auto_reply !== null)
                ? model_1.AutoReply.fromPartial(object.auto_reply)
                : undefined;
        return message;
    },
};
function createBaseListAutoRepliesRequest() {
    return {};
}
exports.ListAutoRepliesRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListAutoRepliesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ListAutoRepliesRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseListAutoRepliesRequest();
        return message;
    },
};
function createBaseListAutoRepliesResponse() {
    return { auto_replies: [] };
}
exports.ListAutoRepliesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.auto_replies) {
            model_1.AutoReply.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListAutoRepliesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.auto_replies.push(model_1.AutoReply.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            auto_replies: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.auto_replies)
                ? object.auto_replies.map((e) => model_1.AutoReply.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.auto_replies) === null || _a === void 0 ? void 0 : _a.length) {
            obj.auto_replies = message.auto_replies.map((e) => model_1.AutoReply.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ListAutoRepliesResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseListAutoRepliesResponse();
        message.auto_replies =
            ((_a = object.auto_replies) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.AutoReply.fromPartial(e))) || [];
        return message;
    },
};
function createBaseGetAutoReplyRequest() {
    return { id: "" };
}
exports.GetAutoReplyRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetAutoReplyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.GetAutoReplyRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseGetAutoReplyRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseGetAutoReplyResponse() {
    return { auto_reply: undefined };
}
exports.GetAutoReplyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.auto_reply !== undefined) {
            model_1.AutoReply.encode(message.auto_reply, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetAutoReplyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.auto_reply = model_1.AutoReply.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            auto_reply: isSet(object.auto_reply)
                ? model_1.AutoReply.fromJSON(object.auto_reply)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.auto_reply !== undefined) {
            obj.auto_reply = model_1.AutoReply.toJSON(message.auto_reply);
        }
        return obj;
    },
    create(base) {
        return exports.GetAutoReplyResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetAutoReplyResponse();
        message.auto_reply =
            (object.auto_reply !== undefined && object.auto_reply !== null)
                ? model_1.AutoReply.fromPartial(object.auto_reply)
                : undefined;
        return message;
    },
};
function createBaseUpdateAutoReplyRequest() {
    return { id: "", question: undefined, answer: undefined };
}
exports.UpdateAutoReplyRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.question !== undefined) {
            model_1.AutoReplyQuestion.encode(message.question, writer.uint32(18).fork())
                .ldelim();
        }
        if (message.answer !== undefined) {
            model_1.AutoReplyAnswer.encode(message.answer, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateAutoReplyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.question = model_1.AutoReplyQuestion.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.answer = model_1.AutoReplyAnswer.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            question: isSet(object.question)
                ? model_1.AutoReplyQuestion.fromJSON(object.question)
                : undefined,
            answer: isSet(object.answer)
                ? model_1.AutoReplyAnswer.fromJSON(object.answer)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.question !== undefined) {
            obj.question = model_1.AutoReplyQuestion.toJSON(message.question);
        }
        if (message.answer !== undefined) {
            obj.answer = model_1.AutoReplyAnswer.toJSON(message.answer);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateAutoReplyRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseUpdateAutoReplyRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.question =
            (object.question !== undefined && object.question !== null)
                ? model_1.AutoReplyQuestion.fromPartial(object.question)
                : undefined;
        message.answer = (object.answer !== undefined && object.answer !== null)
            ? model_1.AutoReplyAnswer.fromPartial(object.answer)
            : undefined;
        return message;
    },
};
function createBaseUpdateAutoReplyResponse() {
    return { auto_reply: undefined };
}
exports.UpdateAutoReplyResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.auto_reply !== undefined) {
            model_1.AutoReply.encode(message.auto_reply, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateAutoReplyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.auto_reply = model_1.AutoReply.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            auto_reply: isSet(object.auto_reply)
                ? model_1.AutoReply.fromJSON(object.auto_reply)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.auto_reply !== undefined) {
            obj.auto_reply = model_1.AutoReply.toJSON(message.auto_reply);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateAutoReplyResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseUpdateAutoReplyResponse();
        message.auto_reply =
            (object.auto_reply !== undefined && object.auto_reply !== null)
                ? model_1.AutoReply.fromPartial(object.auto_reply)
                : undefined;
        return message;
    },
};
function createBaseDeleteAutoReplyRequest() {
    return { id: "" };
}
exports.DeleteAutoReplyRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteAutoReplyRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.DeleteAutoReplyRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseDeleteAutoReplyRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseDeleteAutoReplyResponse() {
    return {};
}
exports.DeleteAutoReplyResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteAutoReplyResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeleteAutoReplyResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseDeleteAutoReplyResponse();
        return message;
    },
};
function createBaseCreateAnnouncementRequest() {
    return { channel_id: "", text: "", message_id: undefined };
}
exports.CreateAnnouncementRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.text !== "") {
            writer.uint32(18).string(message.text);
        }
        if (message.message_id !== undefined) {
            writer.uint32(24).int64(message.message_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateAnnouncementRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.text = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.message_id = longToString(reader.int64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            text: isSet(object.text) ? globalThis.String(object.text) : "",
            message_id: isSet(object.message_id)
                ? globalThis.String(object.message_id)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.text !== "") {
            obj.text = message.text;
        }
        if (message.message_id !== undefined) {
            obj.message_id = message.message_id;
        }
        return obj;
    },
    create(base) {
        return exports.CreateAnnouncementRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseCreateAnnouncementRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.text = (_b = object.text) !== null && _b !== void 0 ? _b : "";
        message.message_id = (_c = object.message_id) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseCreateAnnouncementResponse() {
    return { announcement: undefined };
}
exports.CreateAnnouncementResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.announcement !== undefined) {
            model_1.Announcement.encode(message.announcement, writer.uint32(10).fork())
                .ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCreateAnnouncementResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.announcement = model_1.Announcement.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            announcement: isSet(object.announcement)
                ? model_1.Announcement.fromJSON(object.announcement)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.announcement !== undefined) {
            obj.announcement = model_1.Announcement.toJSON(message.announcement);
        }
        return obj;
    },
    create(base) {
        return exports.CreateAnnouncementResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseCreateAnnouncementResponse();
        message.announcement =
            (object.announcement !== undefined && object.announcement !== null)
                ? model_1.Announcement.fromPartial(object.announcement)
                : undefined;
        return message;
    },
};
function createBaseDeleteAnnouncementRequest() {
    return { channel_id: "", id: "" };
}
exports.DeleteAnnouncementRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.id !== "") {
            writer.uint32(18).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteAnnouncementRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            id: isSet(object.id) ? globalThis.String(object.id) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.id !== "") {
            obj.id = message.id;
        }
        return obj;
    },
    create(base) {
        return exports.DeleteAnnouncementRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseDeleteAnnouncementRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseDeleteAnnouncementResponse() {
    return {};
}
exports.DeleteAnnouncementResponse = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeleteAnnouncementResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.DeleteAnnouncementResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseDeleteAnnouncementResponse();
        return message;
    },
};
function createBaseSetReactionRequest() {
    return { target: undefined, emoji_id: "" };
}
exports.SetReactionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.target !== undefined) {
            model_1.ReactionTarget.encode(message.target, writer.uint32(10).fork()).ldelim();
        }
        if (message.emoji_id !== "") {
            writer.uint32(18).string(message.emoji_id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetReactionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.target = model_1.ReactionTarget.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.emoji_id = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            target: isSet(object.target)
                ? model_1.ReactionTarget.fromJSON(object.target)
                : undefined,
            emoji_id: isSet(object.emoji_id)
                ? globalThis.String(object.emoji_id)
                : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.target !== undefined) {
            obj.target = model_1.ReactionTarget.toJSON(message.target);
        }
        if (message.emoji_id !== "") {
            obj.emoji_id = message.emoji_id;
        }
        return obj;
    },
    create(base) {
        return exports.SetReactionRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSetReactionRequest();
        message.target = (object.target !== undefined && object.target !== null)
            ? model_1.ReactionTarget.fromPartial(object.target)
            : undefined;
        message.emoji_id = (_a = object.emoji_id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseSetReactionResponse() {
    return { reaction: undefined, has_reacted: false };
}
exports.SetReactionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reaction !== undefined) {
            model_1.Reaction.encode(message.reaction, writer.uint32(10).fork()).ldelim();
        }
        if (message.has_reacted !== false) {
            writer.uint32(16).bool(message.has_reacted);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSetReactionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.reaction = model_1.Reaction.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.has_reacted = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            reaction: isSet(object.reaction)
                ? model_1.Reaction.fromJSON(object.reaction)
                : undefined,
            has_reacted: isSet(object.has_reacted)
                ? globalThis.Boolean(object.has_reacted)
                : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.reaction !== undefined) {
            obj.reaction = model_1.Reaction.toJSON(message.reaction);
        }
        if (message.has_reacted !== false) {
            obj.has_reacted = message.has_reacted;
        }
        return obj;
    },
    create(base) {
        return exports.SetReactionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSetReactionResponse();
        message.reaction =
            (object.reaction !== undefined && object.reaction !== null)
                ? model_1.Reaction.fromPartial(object.reaction)
                : undefined;
        message.has_reacted = (_a = object.has_reacted) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
function createBaseListReactionRequest() {
    return {
        target: undefined,
        emoji_id: undefined,
        paging_key: undefined,
        limit: undefined,
    };
}
exports.ListReactionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.target !== undefined) {
            model_1.ReactionTarget.encode(message.target, writer.uint32(10).fork()).ldelim();
        }
        if (message.emoji_id !== undefined) {
            writer.uint32(26).string(message.emoji_id);
        }
        if (message.paging_key !== undefined) {
            writer.uint32(34).string(message.paging_key);
        }
        if (message.limit !== undefined) {
            writer.uint32(40).int32(message.limit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListReactionRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.target = model_1.ReactionTarget.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.emoji_id = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.paging_key = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.limit = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            target: isSet(object.target)
                ? model_1.ReactionTarget.fromJSON(object.target)
                : undefined,
            emoji_id: isSet(object.emoji_id)
                ? globalThis.String(object.emoji_id)
                : undefined,
            paging_key: isSet(object.paging_key)
                ? globalThis.String(object.paging_key)
                : undefined,
            limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.target !== undefined) {
            obj.target = model_1.ReactionTarget.toJSON(message.target);
        }
        if (message.emoji_id !== undefined) {
            obj.emoji_id = message.emoji_id;
        }
        if (message.paging_key !== undefined) {
            obj.paging_key = message.paging_key;
        }
        if (message.limit !== undefined) {
            obj.limit = Math.round(message.limit);
        }
        return obj;
    },
    create(base) {
        return exports.ListReactionRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseListReactionRequest();
        message.target = (object.target !== undefined && object.target !== null)
            ? model_1.ReactionTarget.fromPartial(object.target)
            : undefined;
        message.emoji_id = (_a = object.emoji_id) !== null && _a !== void 0 ? _a : undefined;
        message.paging_key = (_b = object.paging_key) !== null && _b !== void 0 ? _b : undefined;
        message.limit = (_c = object.limit) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseListReactionResponse() {
    return { reactions: [], total_count: "0", next_paging_key: undefined };
}
exports.ListReactionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.reactions) {
            model_1.Reaction.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.total_count !== "0") {
            writer.uint32(16).int64(message.total_count);
        }
        if (message.next_paging_key !== undefined) {
            writer.uint32(26).string(message.next_paging_key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseListReactionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.reactions.push(model_1.Reaction.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.total_count = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.next_paging_key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            reactions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.reactions)
                ? object.reactions.map((e) => model_1.Reaction.fromJSON(e))
                : [],
            total_count: isSet(object.total_count)
                ? globalThis.String(object.total_count)
                : "0",
            next_paging_key: isSet(object.next_paging_key)
                ? globalThis.String(object.next_paging_key)
                : undefined,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.reactions) === null || _a === void 0 ? void 0 : _a.length) {
            obj.reactions = message.reactions.map((e) => model_1.Reaction.toJSON(e));
        }
        if (message.total_count !== "0") {
            obj.total_count = message.total_count;
        }
        if (message.next_paging_key !== undefined) {
            obj.next_paging_key = message.next_paging_key;
        }
        return obj;
    },
    create(base) {
        return exports.ListReactionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseListReactionResponse();
        message.reactions = ((_a = object.reactions) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.Reaction.fromPartial(e))) ||
            [];
        message.total_count = (_b = object.total_count) !== null && _b !== void 0 ? _b : "0";
        message.next_paging_key = (_c = object.next_paging_key) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseGetMembersRequest() {
    return { channel_id: "", paging_key: undefined, limit: undefined };
}
exports.GetMembersRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.paging_key !== undefined) {
            writer.uint32(18).string(message.paging_key);
        }
        if (message.limit !== undefined) {
            writer.uint32(24).int32(message.limit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetMembersRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.paging_key = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.limit = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            paging_key: isSet(object.paging_key)
                ? globalThis.String(object.paging_key)
                : undefined,
            limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.paging_key !== undefined) {
            obj.paging_key = message.paging_key;
        }
        if (message.limit !== undefined) {
            obj.limit = Math.round(message.limit);
        }
        return obj;
    },
    create(base) {
        return exports.GetMembersRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseGetMembersRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.paging_key = (_b = object.paging_key) !== null && _b !== void 0 ? _b : undefined;
        message.limit = (_c = object.limit) !== null && _c !== void 0 ? _c : undefined;
        return message;
    },
};
function createBaseGetMembersResponse() {
    return { members: [], next_paging_key: undefined };
}
exports.GetMembersResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.members) {
            model_1.User.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.next_paging_key !== undefined) {
            writer.uint32(18).string(message.next_paging_key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetMembersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.members.push(model_1.User.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.next_paging_key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            members: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.members)
                ? object.members.map((e) => model_1.User.fromJSON(e))
                : [],
            next_paging_key: isSet(object.next_paging_key)
                ? globalThis.String(object.next_paging_key)
                : undefined,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.members) === null || _a === void 0 ? void 0 : _a.length) {
            obj.members = message.members.map((e) => model_1.User.toJSON(e));
        }
        if (message.next_paging_key !== undefined) {
            obj.next_paging_key = message.next_paging_key;
        }
        return obj;
    },
    create(base) {
        return exports.GetMembersResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetMembersResponse();
        message.members = ((_a = object.members) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.User.fromPartial(e))) || [];
        message.next_paging_key = (_b = object.next_paging_key) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseGetMemberRequest() {
    return {
        channel_id: "",
        user_id: "0",
        user_type: model_1.User_Type.TYPE_UNSPECIFIED,
    };
}
exports.GetMemberRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.user_id !== "0") {
            writer.uint32(16).int64(message.user_id);
        }
        if (message.user_type !== model_1.User_Type.TYPE_UNSPECIFIED) {
            writer.uint32(24).int32((0, model_1.user_TypeToNumber)(message.user_type));
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetMemberRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) {
                        break;
                    }
                    message.user_id = longToString(reader.int64());
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.user_type = (0, model_1.user_TypeFromJSON)(reader.int32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            user_id: isSet(object.user_id) ? globalThis.String(object.user_id) : "0",
            user_type: isSet(object.user_type)
                ? (0, model_1.user_TypeFromJSON)(object.user_type)
                : model_1.User_Type.TYPE_UNSPECIFIED,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.user_id !== "0") {
            obj.user_id = message.user_id;
        }
        if (message.user_type !== model_1.User_Type.TYPE_UNSPECIFIED) {
            obj.user_type = (0, model_1.user_TypeToJSON)(message.user_type);
        }
        return obj;
    },
    create(base) {
        return exports.GetMemberRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = createBaseGetMemberRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.user_id = (_b = object.user_id) !== null && _b !== void 0 ? _b : "0";
        message.user_type = (_c = object.user_type) !== null && _c !== void 0 ? _c : model_1.User_Type.TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseGetMemberResponse() {
    return { member: undefined };
}
exports.GetMemberResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.member !== undefined) {
            model_1.User.encode(message.member, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetMemberResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.member = model_1.User.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            member: isSet(object.member) ? model_1.User.fromJSON(object.member) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.member !== undefined) {
            obj.member = model_1.User.toJSON(message.member);
        }
        return obj;
    },
    create(base) {
        return exports.GetMemberResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseGetMemberResponse();
        message.member = (object.member !== undefined && object.member !== null)
            ? model_1.User.fromPartial(object.member)
            : undefined;
        return message;
    },
};
function createBaseSearchMembersRequest() {
    return {
        channel_id: "",
        nickname: "",
        limit: undefined,
        paging_key: undefined,
        exclude_me: undefined,
    };
}
exports.SearchMembersRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.channel_id !== "") {
            writer.uint32(10).string(message.channel_id);
        }
        if (message.nickname !== "") {
            writer.uint32(18).string(message.nickname);
        }
        if (message.limit !== undefined) {
            writer.uint32(24).int32(message.limit);
        }
        if (message.paging_key !== undefined) {
            writer.uint32(34).string(message.paging_key);
        }
        if (message.exclude_me !== undefined) {
            writer.uint32(40).bool(message.exclude_me);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchMembersRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.channel_id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.nickname = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.limit = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.paging_key = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) {
                        break;
                    }
                    message.exclude_me = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            channel_id: isSet(object.channel_id)
                ? globalThis.String(object.channel_id)
                : "",
            nickname: isSet(object.nickname)
                ? globalThis.String(object.nickname)
                : "",
            limit: isSet(object.limit) ? globalThis.Number(object.limit) : undefined,
            paging_key: isSet(object.paging_key)
                ? globalThis.String(object.paging_key)
                : undefined,
            exclude_me: isSet(object.exclude_me)
                ? globalThis.Boolean(object.exclude_me)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.channel_id !== "") {
            obj.channel_id = message.channel_id;
        }
        if (message.nickname !== "") {
            obj.nickname = message.nickname;
        }
        if (message.limit !== undefined) {
            obj.limit = Math.round(message.limit);
        }
        if (message.paging_key !== undefined) {
            obj.paging_key = message.paging_key;
        }
        if (message.exclude_me !== undefined) {
            obj.exclude_me = message.exclude_me;
        }
        return obj;
    },
    create(base) {
        return exports.SearchMembersRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseSearchMembersRequest();
        message.channel_id = (_a = object.channel_id) !== null && _a !== void 0 ? _a : "";
        message.nickname = (_b = object.nickname) !== null && _b !== void 0 ? _b : "";
        message.limit = (_c = object.limit) !== null && _c !== void 0 ? _c : undefined;
        message.paging_key = (_d = object.paging_key) !== null && _d !== void 0 ? _d : undefined;
        message.exclude_me = (_e = object.exclude_me) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseSearchMembersResponse() {
    return { members: [], next_paging_key: undefined };
}
exports.SearchMembersResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.members) {
            model_1.User.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.next_paging_key !== undefined) {
            writer.uint32(18).string(message.next_paging_key);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSearchMembersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.members.push(model_1.User.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.next_paging_key = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            members: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.members)
                ? object.members.map((e) => model_1.User.fromJSON(e))
                : [],
            next_paging_key: isSet(object.next_paging_key)
                ? globalThis.String(object.next_paging_key)
                : undefined,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.members) === null || _a === void 0 ? void 0 : _a.length) {
            obj.members = message.members.map((e) => model_1.User.toJSON(e));
        }
        if (message.next_paging_key !== undefined) {
            obj.next_paging_key = message.next_paging_key;
        }
        return obj;
    },
    create(base) {
        return exports.SearchMembersResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseSearchMembersResponse();
        message.members = ((_a = object.members) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.User.fromPartial(e))) || [];
        message.next_paging_key = (_b = object.next_paging_key) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseSendButtonPostbackRequest() {
    return { payload: "" };
}
exports.SendButtonPostbackRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.payload !== "") {
            writer.uint32(10).string(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendButtonPostbackRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            payload: isSet(object.payload) ? globalThis.String(object.payload) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.payload !== "") {
            obj.payload = message.payload;
        }
        return obj;
    },
    create(base) {
        return exports.SendButtonPostbackRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseSendButtonPostbackRequest();
        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseSendButtonPostbackResponse() {
    return { button_postback_action: undefined };
}
exports.SendButtonPostbackResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.button_postback_action !== undefined) {
            model_1.ButtonPostbackAction.encode(message.button_postback_action, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSendButtonPostbackResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.button_postback_action = model_1.ButtonPostbackAction.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            button_postback_action: isSet(object.button_postback_action)
                ? model_1.ButtonPostbackAction.fromJSON(object.button_postback_action)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.button_postback_action !== undefined) {
            obj.button_postback_action = model_1.ButtonPostbackAction.toJSON(message.button_postback_action);
        }
        return obj;
    },
    create(base) {
        return exports.SendButtonPostbackResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        const message = createBaseSendButtonPostbackResponse();
        message.button_postback_action =
            (object.button_postback_action !== undefined &&
                object.button_postback_action !== null)
                ? model_1.ButtonPostbackAction.fromPartial(object.button_postback_action)
                : undefined;
        return message;
    },
};
function createBaseGetFiltersRequest() {
    return {};
}
exports.GetFiltersRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetFiltersRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetFiltersRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseGetFiltersRequest();
        return message;
    },
};
function createBaseGetFiltersResponse() {
    return { service_filters: [], common_filters: [] };
}
exports.GetFiltersResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.service_filters) {
            model_1.Filter.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.common_filters) {
            model_1.Filter.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader
            ? input
            : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseGetFiltersResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.service_filters.push(model_1.Filter.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.common_filters.push(model_1.Filter.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            service_filters: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.service_filters)
                ? object.service_filters.map((e) => model_1.Filter.fromJSON(e))
                : [],
            common_filters: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.common_filters)
                ? object.common_filters.map((e) => model_1.Filter.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b;
        const obj = {};
        if ((_a = message.service_filters) === null || _a === void 0 ? void 0 : _a.length) {
            obj.service_filters = message.service_filters.map((e) => model_1.Filter.toJSON(e));
        }
        if ((_b = message.common_filters) === null || _b === void 0 ? void 0 : _b.length) {
            obj.common_filters = message.common_filters.map((e) => model_1.Filter.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetFiltersResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseGetFiltersResponse();
        message.service_filters =
            ((_a = object.service_filters) === null || _a === void 0 ? void 0 : _a.map((e) => model_1.Filter.fromPartial(e))) || [];
        message.common_filters =
            ((_b = object.common_filters) === null || _b === void 0 ? void 0 : _b.map((e) => model_1.Filter.fromPartial(e))) || [];
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (globalThis.Number(t.seconds) || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return toTimestamp(o);
    }
    else if (typeof o === "string") {
        return toTimestamp(new globalThis.Date(o));
    }
    else {
        return timestamp_1.Timestamp.fromJSON(o);
    }
}
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
